import Vue from "vue";
import Vuex from "vuex";
import {
  getPlanificacionAnual, getPlanificacionSemanal, getProductosPorContenedor
} from "@/constants/lineas";
import { GetDataProveedores, getExtraCostos, getTiposExtraCostos, validarNumeroContenedor } from "../constants/lineas";

Vue.use(Vuex);
export default {
  namespaced: true,
  state: {
    //Buscador
    bl_search_carrier_booking_number: "",
    dataResultadoBooking: [],
    dataResultadoContainers: [[]],
    dataResultadoBillLadings: [],
    //Filtros Bookings
    dataListaCliente: [],
    dataListaClienteLA: [],
    dataListaNaviera: [],
    dataListaNavierasNoUCC: [],
    dataListaTipo: [],
    dataListaPOD: [],
    dataListaPodLA: [],
    dataListaComercial: [],
    dataListaComercialLA: [],
    dataListaNave: [],
    dataListaSemana: [],
    dataListaSemanaLA: [],
    dataListaPOL: [],
    dataListaProducto: [],
    dataListaEstado: [],
    dataListaSI: [],
    dataListaTipoSI: [],
    dataListaDestinos: [],

    //////////////////////
    dataListaSemanaInicio: [],
    dataListaSemanaTermino: [],
    dataListaAnio: [],
    dataListaAnioLA: [],
    dataListaServicioIntegral: [],

    dataListaNombreServicios: [],
    //Actualizar Solicitud
    dataMotivo: [],

    currentFiltersBookings: {},
    flagFiltersBookings: false,
    flagFiltersPlanificacionSemanal: false,
    //Fin Actualizar Solicitud

    //Fin Filtros Bookings

    //Filtros Itinerarios
    // dataFiltroNaves: [],
    // dataFiltroNavieras: [],
    // dataFiltroServicios: [],
    dataFiltroSemanas: [],
    dataFiltroAnios: [],
    dataFiltroPols: [],
    //Fin Filtros Itinerarios
    // ***************************************************************************

    //Itinerarios
    // ***************************************************************************
    dataListaServicios: [],
    dataItinerariosServiciosPuertosTransbordos: [],
    // Información para data tables

    //Por Aceptar
    dataDatatableVerMisBookingsPorAceptar: [],
    dataDatatableVerMisBookingsPorAceptarFiltrada: [],

    // dataVerBookingsPorAceptar: [],
    // dataVerBookingsPorAceptarFiltrada: [],

    //Por Confirmar
    dataDatatableBookingsPorConfirmar: [],
    dataDatatableBookingsPorConfirmarFiltrada: [],
    //Confirmados
    dataDatatableBookingsConfirmados: [],
    dataDatatableBookingsConfirmadosFiltrada: [],
    //Solicitud Modificacion
    dataDatatableBookingsSolicitudesModificacion: [],
    dataDatatableBookingsSolicitudesModificacionFiltrada: [],
    // Historial Solicitud de Modificacion
    dataDatatableHistorialSolicitudModificacion: [],
    dataDatatableHistorialSolicitudModificacionFiltrada: [],
    //Cancelados
    dataDatatableBookingsCancelados: [],
    dataDatatableBookingsCanceladosFiltrada: [],
    //Embarcados
    dataDatatableBookingsEmbarcados: [],
    dataDatatableBookingsEmbarcadosFiltrada: [],
    //tracking
    dataDatatableTrackingBookings: [],
    dataDatatableTrackingBookingsFiltered: [],
    //Declarados Cancelados
    dataDatatableBookingsDeclaradosCancelados: [],
    dataDatatableBookingsDeclaradosCanceladosFiltrada: [],
    // ***************************************************************************
    // Perfil Administrador
    // ***************************************************************************
    //Solicitado
    dataDatatableBookingsSolicitados: [],
    dataDatatableBookingsSolicitadosFiltrada: [],
    //Declarado
    dataDatatableBookingsDeclarados: [],
    dataDatatableDeclaradosFiltrada: [],

    dataDatatableBookingsDeclaradosFiltrada: [],
    dataAceptarBookingDeclarados: [],

    //Historiales
    // Late Arrivals
    dataDataTableHistorialLateArrivals: [],
    //Historial Por Confirmar
    dataDatatableHistorialBookingPorConfirmar: [],
    //Historial Confirmados
    dataDatatableHistorialBookingConfirmados: [],
    //Historial Embarcado
    dataDatatableHistorialEmbarcados: [],
    //Historial Cancelado
    dataDatatableHistorialCancelado: [],
    //Historial Declarado Cancelado
    dataDatatableHistorialDeclaradoCancelado: [],
    //Historial Solicitado
    dataDatatableHistorialSolicitado: [],
    //Historial Declarado
    dataDatatableHistorialDeclarado: [],
    //Servicios
    dataDatatableServicios: [],
    dataDatatableServiciosFiltrada: [],

    dataDatatableServiciosPuertos: [],
    dataDatatableServiciosPuertosFiltrada: [],

    dataDatatableServiciosTransbordos: [],
    dataDatatableServiciosTransbordosFiltrada: [],

    dataDatatableServiciosTransbordosPuertos: [],
    dataDatatableServiciosTransbordosPuertosFiltrada: [],

    dataDatatableItinerariosTransbordos: [],
    dataDatatableItinerariosTransbordosFiltrada: [],

    dataDatatableServiciosDetalles: [],
    dataDatatableServiciosDetallesFiltrada: [],

    //Itinerarios
    dataDatatableListarItinerarios: [],
    dataDatatableListarItinerariosFiltrada: [],
    dataDatatableListarItinerariosPuertosEmbarque: [],
    dataDatatableListarItinerariosPuertosEmbarqueFiltrada: [],
    hasFilterItinerarios: false,
    dataFiltrosItinerarios: {},

    //Busqueda Itinerarios
    dataDatatableListarBusquedaItinerarios: [],
    dataDatatableListarBusquedaItinerariosFiltrada: [],

    estadoListarItinerarios: false,

    //Tarifas
    dataDatatableTarifasContratos: [],
    dataDatatableTarifasContratosFiltrada: [],

    dataDatatableTarifasAcuerdosLineas: [],
    dataDatatableTarifasAcuerdosLineasFull: [],
    dataDatatableTarifasAcuerdosLineasInicial: [],
    dataDatatableTarifasAcuerdosLineasFiltrada: [],

    dataDatatableTarifasAcuerdosClientesBase: [],
    dataDatatableTarifasAcuerdosClientesBaseFiltrada: [],

    dataDatatableTarifasAcuerdosClientes: [],
    dataDatatableTarifasAcuerdosClientesFiltrada: [],

    dataDatatableTarifasLineas: [],
    dataDatatableTarifasLineasFiltrada: [],

    dataDatatableTarifasDescuentosClientes: [],
    dataDatatableTarifasDescuentosClientesFiltrada: [],

    dataDatatableTarifasReporteTarifaEmbarcados: [],
    dataDatatableTarifasReporteTarifaEmbarcadosFiltrada: [],

    filterStateAcuerdosLineas: null,
    filterStateAcuerdosClientesBase: null,
    filterStateAcuerdosClientes: null,
    filterStateRecargos: null,

    dataDatatableTarifasRecargos: [],

    dataDatatableTarifasRecargosTypes: [],
    showModalAgregarTarifasRecargos: false,
    showModalFiltrosTarifasRecargos: false,
    showModalEditarTarifasRecargo: false,
    showModalEditarRecargosType: false,
    showModalVerDetalleTarifasRecargo: false,
    showModalRecargoType: false,
    recargoTypeLoading: false,
    dataEditarRecargoType: false,
    dataDuplicarRecargoType: null,
    dataRecargosAsociados: null,


    filtroTypeRecharge: [],
    filtroNaviera: [],
    filtroPol: [],
    filtroPod: [],
    filtroAtmosfera: [],
    filtroContainer: [],
    filtroCommodity: [],
    filtroUnityPayment: [],

    //populate selects
    selectCommodities: [],
    selectAtmospheres: [],
    selectContainers: [],
    selectContract: [],


    //Late Arrivals
    dataDatatableBookingsLateArrivals: [],
    dataDatatableBookingsLateArrivalsFiltrada: [],

    //----------------planificacion semanal------------
    psShowManageModal: false,
    psShowReportModal: false,
    psCreateMode: false,
    psMultipleEditMode: false,
    psEnabledButtons: true,

    psWeekTotals: {
      week1: [0, 0, 0],
      week2: [0, 0, 0],
      week3: [0, 0, 0],
      week4: [0, 0, 0],
      week5: [0, 0, 0]
    },

    psResumeDataTable: [],
    psResumeDataTableFiltrada: [],
    psIsAdmin: false,
    psShowDetail: false,
    psDetailPort: "",
    psDataTable: [],
    psDataTableFiltrada: [],

    psDataSelected: [],
    psDataSelectedToDelete: [],

    psEnabledNotifications: false,
    psProductsPrefix: "ps-",
    psNewPlanningProducts: [],
    psExistingPlanningProducts: {},
    psAddedPlanningProducts: {},

    psCurrentWeeks: [],

    psListaPuertos: [],
    psListaClientes: [],
    psListaContenedores: [],
    psListaProductos: [],

    psFiltroPuertos: [],
    psFiltroClientes: [],
    psFiltroSemanas: [],
    psFiltroContenedores: [],
    psFiltroProductos: [],
    psFiltroAnios: [],

    //--------------------------------------------------

    //Variables Auxiliares
    idAuxiliarBookingSeleccionado: "",
    idAuxiliarServicioSeleccionado: "",
    idAuxiliarServicioPuertoSeleccionado: "",
    idAuxiliarTransbordoSeleccionado: "",
    idAuxiliarItinerarioSeleccionado: "",

    //Booking declarados
    visibleModalEditarBookingDeclarado: false,
    //Ventanas Modales
    visibleModalInformacionGeneral: false,
    visibleModalInformacionGeneralLateArrival: false,
    visibleModalInformacionServicio: false,
    visibleModalEditarLateArrival: false,
    visibleModalAgregarLateArrival: false,

    visibleModalAgregarBlNumber: false,
    

    visibleModalEmbarcarBooking: false,

    visibleModalEditarContrato: false,

    visibleModalRealizarSolicitudModificacion: false,

    visibleModalEditarServicio: false,

    visibleModalEditarServicioPuerto: false,
    visibleModalEditarServicioTransbordo: false,
    visibleModalEditarServicioTransbordoPuerto: false,
    visibleModalEditarItinerarioTransbordo: false,

    visibleModalEditarItinerario: false,
    visibleModalReservarItinerario: false,

    visibleModalEditarItinerariosPuertosEmbarque: false,
    visibleModalEditarItinerariosDestinosFinales: false,

    visibleModalDetallesItinerario: false,
    visibleModalReservaBooking: false,
    visibleModalTracking: false,
    visibleModalAceptarBookingDeclarado: false,
    visibleModalAceptarBookingDeclaradoBuscarReserva: false,
    visibleModalCambiarServicioBooking: false,
    visibleModalCambiarServicioConfirmadoBooking: false,

    visibleModalDetalleSolicitudModificacion: false,

    visibleModalEditarTarifaContrato: false,

    // Variables auxiliares para abrir y cerrar modales
    auxModalBookingConfirmados: false,
    auxModalBookingEmbarcado: false,

    // Validación de formulario validado (Nueva solicitud de reserva no planificada)
    estadoSolicitudReservaPlanificada: false,

    // Formularios auxiliares
    formularioSolicitudNoPlanificada: [],

    dataAnios: [],
    dataSemanas: [],
    dataContenedores: [],
    dataPuertoDescarga: [],
    dataserviciosIntegrales: [],
    dataShippers: [],
    shippers: [],
    dataShippersAddress: [],
    dataProducts: [],
    dataMetodosPago: [],
    dataTarifaContrato: [],

    listaProductosExportar: [],
    listaShippers: [],
    listaPacking: [],
    listaDireccionesShipper: [],

    listaConsignatarios: [],
    listaNotificados: [],
    listaAtmosferas: [],
    listaAnios: [],
    listaAniosACopiar: [],
    listaClientes: [],
    listaClientesPap: [],
    listaClientesApe: [],
    listaServIntegral: [],


    // actionSetYearsList
    // actionSetClientsList
    // actionSetServIntegralList



    abrirModalSeleccionarNave: false,
    dataNaveSeleccionada: [],

    visibleModalSeleccionNave: false,
    visibleModalSeleccionNaveActualizar: false,
    visibleModalReservaBookingAux: false,
    visibleModalSeleccionarTickeadosConfirmados: [],
    visibleModalSeleccionarTickeadosSolicitados: [],

    visibleModalEditarSimpleAcuerdoLinea: [],
    visibleModalVerRecargosAsociados: false,
    visibleModalVerHistorialClientesBase: false,
    visibleModalDuplicarContrato: false,
    visibleModalDuplicarAcuerdoLinea: [],
    visibleModalEditarPuertoItinerarios: [],

    nuevoTransbordoAux: [],

    // Datos auxiliares para elegir servicio en Bookings Declarados (Aceptar Booking)
    polAux: "",
    naveAux: "",
    viajeAux: "",
    visibleModalUtilizarReservaAnterior: false,

    // prueba actualizar tabla y filtrar
    formFiltroAcuerdoCliente: false,

    // Indicadores trencito booking
    contadorMenuBookings: [],
    dataFormAgregarReservaFromItinerary: {},

    visibleModalInformacionPlanificacionAnual: false,
    habilitarEdicionMultipleAnual: false,

    puertosSeleccionadosPlanAnual: {
      tab_1: false,
      tab_2: false,
      tab_3: false,
      tab_4: false,
      tab_5: false,
    },

    checkPlanificacionAnual: [],
    dataAnioSeleccionado: [],

    // Filtros
    lista_anios: [],
    lista_clientes: [],
    lista_productos: [],
    lista_contenedores: [],
    lista_consignatarios: [],
    lista_puertos: [],
    lista_serv_integral: [],

    // Nuevos puertos
    nuevosConsolidadoMultiples: [],
    nuevosPuertosMultiplesAgregados: [],
    nuevosPlanificacionAnualMultiple: [],

    // Eliminación de puertos
    puertoParaEliminarPlanificacionAnual: -1,
    eliminacionConsolidado: false,
    eliminacionTab1: false,
    eliminacionTab2: false,
    eliminacionTab3: false,
    eliminacionTab4: false,

    // valor de select por defecto
    product_selected: [],
    container_selected: [],
    annual_plan_id: "",

    reservaInformacionGeneralModal: false,
    tariffSelectedRechargeAction: undefined,
    visibleModalAsignarTarifasRecargos: undefined,

    dataPlanificacionAnualTabla: [],
    dataResumenPlanificacionSemanalTabla: [],
    dataPlanificacionSemanalTabla: [],

    yearsFilter: [],
    clienstFilter: [],
    containersFilter: [],
    productsFilter: [],
    servIntegralFilter: [],
    consigneeFilter: [],
    portFilter: [],
    dataFiltradaPlanificacionAnual: [],
    paShowReportModal: false,

    //Buscador
    showModalBuscarReservaDeclaradoAceptar: false,
    showModalBuscarReservaDeclaradoVerDetalle: false,
    showModalBuscarReservaDeclaradoEditar: false,

    // showModalDeclaradoVerDetalle: false,
    goTabSolicitudReserva: '',
    infoSolicitudModificacion: {},
    polEtdItinerary: null,
    inactiveDeleteTariffLineByFilter: true,
    stateIdDeclarados: null,
    idBookingItinerary: null,
    tariffRechargeDescription: [],
    logistaasOptions: [],
    loadingTableConfirmados: true,
    showModalCostosSIBooking: false,
    isBookingPlanned: 0,
    loadingItineraryTable: false,
    loadingTableCancelados: false,
    loadingTableCanceladosDeclarados: false,


    // Datatables
    loadingTableItinerarySearch: false,
    showModalfilterItinerary: false,
    showModalfilterTariffLines: false,
    showModalImportRecharges: false,
    isExtraCostosTipoLoading: false,
    showModalTiposExtraCosto: false,
    dataExtraCostosTipos: [],
    dataExtraCostosTiposBase: [],
    dataNumeroContenedor: [],
    dataUnidadPago: [],
    dataSelectContainer: [],
    isExtraCostosLoading: false,
    dataExtraCostos: [],
    dataExtraCostosBase: [],
    showModalExtraCosto: false,

    formasPagoLista: [],
    tipoUnidadLista: [],
    tiposExtraCostos: [],
    tiposMonedasLista: [],
    tiposCargosLista: [],
    methodPay: [],
    showModalRechargesNavieras: false,
    dataDataTableQuotationImporter: [],
    dataDataTableQuotationImporterLoading: false,
    showDataTableQuotationImporterModal: false,
    showModalAddValueDictionary: false,

    //clientDiscounts
    showModalCustomerDiscountsRecharges: false,

    //tariffLines
    showModalTariffLinesRecharges: false,

    //Recargos
    rechargeTypes: [],

    dataProveedores: [],
    loadingAdmExtraCostos: false,

    dataPlantsProveedores: [],

    currentFiltersPlanificacionSemanal: []
  },

  // 2
  mutations: {

    setInactiveDeleteTariffLineByFilter(state, payload) {
      state.inactiveDeleteTariffLineByFilter = payload;
    },
    setInfoSolicitudModificacion(state, payload) {
      state.infoSolicitudModificacion = payload
    },
    setTariffSelectedRechargeAction(state, payload) {
      state.tariffSelectedRechargeAction = payload;
    },
    setModalAsignarTarifasRecargos(state, payload) {
      state.visibleModalAsignarTarifasRecargos = payload;
    },
    // ***************************************************************************
    //Buscador
    // ***************************************************************************
    setBlSearchCarrierBookingNumber(state, payload) {
      state.bl_search_carrier_booking_number = payload;
    },

    setDataResultadoBooking(state, payload) {
      state.dataResultadoBooking = payload;
    },

    setDataResultadoContainers(state, payload) {
      state.dataResultadoContainers = payload;
    },

    setDataResultadoBillLadings(state, payload) {
      state.dataResultadoBillLadings = payload;
    },
    // ***************************************************************************
    //Filtros Bookings
    // ***************************************************************************
    setDataListaCliente(state, payload) {
      state.dataListaCliente = payload;
    },

    setDataListaClienteLA(state, payload) {
      state.dataListaClienteLA = payload;
    },

    setDataListaNaviera(state, payload) {
      state.dataListaNaviera = payload;
    },

    setDataListaNavierasNoUCC(state, payload) {
      state.dataListaNavierasNoUCC = payload;
    },

    setDataListaTipo(state, payload) {
      state.dataListaTipo = payload;
    },

    setDataListaServicios(state, payload) {
      state.dataListaServicios = payload;
    },

    setDataItinerariosServiciosPuertosTransbordos(state, payload) {
      state.dataItinerariosServiciosPuertosTransbordos = payload;
    },

    setDataListaPOD(state, payload) {
      state.dataListaPOD = payload;
    },

    setDataListaPodLA(state, payload) {
      state.dataListaPodLA = payload;
    },

    setDataListaComercial(state, payload) {
      state.dataListaComercial = payload;
    },

    setDataListaComercialLA(state, payload) {
      state.dataListaComercialLA = payload;
    },

    setDataListaNave(state, payload) {
      state.dataListaNave = payload;
    },

    setDataListaSemana(state, payload) {
      state.dataListaSemana = payload;
    },

    setDataListaSemanaLA(state, payload) {
      state.dataListaSemanaLA = payload;
    },

    setDataListaPOL(state, payload) {
      state.dataListaPOL = payload;
    },

    setDataListaProducto(state, payload) {
      state.dataListaProducto = payload;
    },

    setDataListaEstado(state, payload) {
      state.dataListaEstado = payload;
    },
    setDataListaSI(state, payload) {
      state.dataListaSI = payload;
    },
    setDataListaTipoSI(state, payload) {
      state.dataListaTipoSI = payload;
    },
    setDataListaDestinos(state, payload) {
      state.dataListaDestinos = payload;
    },
    //Actualizar Solicitud
    setDataMotivo(state, payload) {
      state.dataMotivo = payload;
    },
    setCurrentFiltersBookings(state, payload) {
      state.currentFiltersBookings = payload;
    },
    setFlagFiltersBookings(state, payload) {
      state.flagFiltersBookings = payload;
    },
    setFlagFiltersPlanificacionSemanal(state, payload) {
      state.flagFiltersPlanificacionSemanal = payload;
    },
    //Filtros Itinerarios
    // setDataFiltroNaves(state, payload) {
    //   state.dataFiltroNaves = payload;
    // },
    // setDataFiltroNavieras(state, payload) {
    //   state.dataFiltroNavieras = payload;
    // },
    // setDataFiltroServicios(state, payload) {
    //   state.dataFiltroServicios = payload;
    // },
    setDataFiltroSemanas(state, payload) {
      state.dataFiltroSemanas = payload;
    },
    setDataFiltroAnios(state, payload) {
      state.dataFiltroAnios = payload;
    },
    setDataFiltroPols(state, payload) {
      state.dataFiltroPols = payload;
    },
    //////////////////////////////////////////
    //Filtros para Bookings Embarcados

    setDataListaSemanaInicio(state, payload) {
      state.dataListaSemanaInicio = payload;
    },

    setDataListaSemanaTermino(state, payload) {
      state.dataListaSemanaTermino = payload;
    },

    setDataListaAnio(state, payload) {
      state.dataListaAnio = payload;
    },

    setDataListaAnioLA(state, payload) {
      state.dataListaAnioLA = payload;
    },

    setDataListaServicioIntegral(state, payload) {
      state.dataListaServicioIntegral = payload;
    },

    setDataListaNombreServicios(state, payload) {
      state.dataListaNombreServicios = payload;
    },

    setDataFormAgregarReservaFromItinerary(state, payload) {
      state.dataFormAgregarReservaFromItinerary = payload;
    },

    /////////////////////////////////////////////
    //Filtros para Bookings Cancelados

    /////////////////////////////////////////////
    //Filtros para Bookings Declarados Cancelados

    //Fin Filtros Bookings

    // Vista Administrador

    // Filter Bookings Solicitados
    filterDataDatatableBookingsSolicitados(state, payload) {
      state.dataDatatableBookingsSolicitadosFiltrada =
        state.dataDatatableBookingsSolicitados;
      state.dataDatatableBookingsSolicitadosFiltrada = payload;
    },
    limpiarDataDatatableBookingsSolicitados(state) {
      state.dataDatatableBookingsSolicitadosFiltrada =
        state.dataDatatableBookingsSolicitados;
    },

    // Filter Bookings Declarados

    filterDataDatatableBookingsDeclarados(state, payload) {
      state.dataDatatableDeclaradosFiltrada = state.dataDatatableBookingsDeclarados;
      state.dataDatatableDeclaradosFiltrada = payload;
    },

    limpiarDataDatatableBookingsDeclarados(state) {
      state.dataDatatableDeclaradosFiltrada = state.dataDatatableBookingsDeclarados;
    },

    // Fin Vista Administrador

    // Filter Bookings Por Aceptar
    filterDataVerMisBookingsPorAceptar(state, payload) {
      state.dataDatatableVerMisBookingsPorAceptarFiltrada =
        state.dataDatatableVerMisBookingsPorAceptar;
      state.dataDatatableVerMisBookingsPorAceptarFiltrada = payload;
    },

    limpiarDataVerMisBookingsPorAceptar(state) {
      state.dataDatatableVerMisBookingsPorAceptarFiltrada =
        state.dataDatatableVerMisBookingsPorAceptar;
    },

    // Filter Bookings Por Confirmar
    filterDataBookingsPorConfirmar(state, payload) {
      state.dataDatatableBookingsPorConfirmarFiltrada =
        state.dataDatatableBookingsPorConfirmar;
      state.dataDatatableBookingsPorConfirmarFiltrada = payload;
    },
    limpiarDataBookingsPorConfirmar(state) {
      state.dataDatatableBookingsPorConfirmarFiltrada =
        state.dataDatatableBookingsPorConfirmar;
    },

    // Filter Bookings Confirmados

    filterDataBookingsConfirmados(state, payload) {
      state.dataDatatableBookingsConfirmadosFiltrada = state.dataDatatableBookingsConfirmados;
      state.dataDatatableBookingsConfirmadosFiltrada = payload;
    },

    limpiarDataBookingsConfirmados(state) {
      state.dataDatatableBookingsConfirmadosFiltrada =
        state.dataDatatableBookingsConfirmados;
    },

    // Filter Solicitud Modificacion

    filterDataSolicitudModificado(state, payload) {
      state.dataDatatableBookingsSolicitudesModificacionFiltrada = state.dataDatatableBookingsSolicitudesModificacion;
      state.dataDatatableBookingsSolicitudesModificacionFiltrada = payload;
    },

    limpiarDataSolicitudModificado(state) {
      state.dataDatatableBookingsSolicitudesModificacionFiltrada =
        state.dataDatatableBookingsSolicitudesModificacion;
    },

    filterDataHistorialSolicitudModificado(state, payload) {
      state.dataDatatableHistorialSolicitudModificacionFiltrada = state.dataDatatableHistorialSolicitudModificacion;
      state.dataDatatableHistorialSolicitudModificacionFiltrada = payload;
    },

    limpiarDataHistorialSolicitudModificado(state) {
      state.dataDatatableHistorialSolicitudModificacionFiltrada = state.dataDatatableHistorialSolicitudModificacion;
    },

    // Filter Bookings Embarcados

    filterDataEmbarcado(state, payload) {
      state.dataDatatableBookingsEmbarcadosFiltrada =
        state.dataDatatableBookingsEmbarcados;
      state.dataDatatableBookingsEmbarcadosFiltrada = payload;
    },

    limpiarDataEmbarcado(state) {
      state.dataDatatableBookingsEmbarcadosFiltrada =
        state.dataDatatableBookingsEmbarcados;
    },

    limpiarDataServicios(state) {
      state.dataDatatableServiciosFiltrada = state.dataDatatableServicios;
    },

    // Filter Bookings Cancelados

    filterDataCancelados(state, payload) {
      state.dataDatatableBookingsCanceladosFiltrada =
        state.dataDatatableBookingsCancelados;
      state.dataDatatableBookingsCanceladosFiltrada = payload;
    },

    limpiarDataCancelados(state) {
      state.dataDatatableBookingsCanceladosFiltrada =
        state.dataDatatableBookingsCancelados;
    },

    // Filter Bookings Declarados Cancelados
    filterDataDeclaradosCancelados(state, payload) {
      state.dataDatatableBookingsDeclaradosCanceladosFiltrada =
        state.dataDatatableBookingsDeclaradosCancelados;
      state.dataDatatableBookingsDeclaradosCanceladosFiltrada = payload;
    },

    limpiarDataDeclaradosCancelados(state) {
      state.dataDatatableBookingsDeclaradosCanceladosFiltrada =
        state.dataDatatableBookingsDeclaradosCancelados;
    },
    // Filter Listar Itinerarios
    filterDataListarItinerarios(state, payload) {
      state.dataDatatableListarItinerariosFiltrada =
        state.dataDatatableListarItinerarios;
      state.dataDatatableListarItinerariosFiltrada = payload;
    },

    // Filter Buscar Itinerarios
    filterDataListarBusquedaItinerarios(state, payload) {
      state.dataDatatableListarBusquedaItinerariosFiltrada =
        state.dataDatatableListarBusquedaItinerarios;
      state.dataDatatableListarBusquedaItinerariosFiltrada = payload;
    },
    limpiarDataListarBusquedaItinerarios(state) {
      state.dataDatatableListarBusquedaItinerariosFiltrada =
        state.dataDatatableListarBusquedaItinerarios;
    },

    setEstadoListarItinerarios(state, payload) {
      state.estadoListarItinerarios = payload;
    },

    // Filter Late Arrivals
    filterDataBookingsLateArrivals(state, payload) {
      state.dataDatatableBookingsLateArrivalsFiltrada =
        state.dataDatatableBookingsLateArrivals;
      state.dataDatatableBookingsLateArrivalsFiltrada = payload;
    },

    limpiarDataBookingsLateArrivals(state) {
      state.dataDatatableBookingsLateArrivalsFiltrada =
        state.dataDatatableBookingsLateArrivals;
    },

    // Filter Tarifas
    filterDataTarifasContratos(state, payload) {
      state.dataDatatableTarifasContratosFiltrada =
        state.dataDatatableTarifasContratos;
      state.dataDatatableTarifasContratosFiltrada = payload;
    },

    limpiarDataTarifasContratos(state) {
      state.dataDatatableTarifasContratosFiltrada =
        state.dataDatatableTarifasContratos;
    },

    filterDataAcuerdosLineas(state, payload) {
      state.dataDatatableTarifasAcuerdosLineasFiltrada =
        state.dataDatatableTarifasAcuerdosLineas;
      state.dataDatatableTarifasAcuerdosLineasFiltrada = payload;
    },
    setDataDatatableTarifasAcuerdosLineasFull(state, payload) {
      state.dataDatatableTarifasAcuerdosLineasFull = payload;
    },

    limpiarDataAcuerdosLineas(state) {
      state.dataDatatableTarifasAcuerdosLineasFiltrada =
        state.dataDatatableTarifasAcuerdosLineas;
    },

    filterDataTarifasLineas(state, payload) {
      state.dataDatatableTarifasLineasFiltrada =
        state.dataDatatableTarifasLineas;
      state.dataDatatableTarifasLineasFiltrada = payload;
    },

    limpiarDataTarifasLineas(state) {
      state.dataDatatableTarifasLineasFiltrada =
        state.dataDatatableTarifasLineas;
    },

    // ***************************************************************************
    // Información para data tables
    // ***************************************************************************
    setDatatableVerMisBookingsPorAceptar(state, payload) {
      state.dataDatatableVerMisBookingsPorAceptar = payload;
      state.dataDatatableVerMisBookingsPorAceptarFiltrada = payload;
    },

    // setDataVerBookingsPorAceptar(state, payload) {
    //   state.dataVerBookingsPorAceptar = payload;
    //   state.dataVerBookingsPorAceptarFiltrada = payload;
    // },

    setDatatableBookingsPorConfirmar(state, payload) {
      state.dataDatatableBookingsPorConfirmar = payload;
      state.dataDatatableBookingsPorConfirmarFiltrada = payload;
    },

    setDatatableBookingsConfirmados(state, payload) {
      state.dataDatatableBookingsConfirmados = payload;
      state.dataDatatableBookingsConfirmadosFiltrada = payload;
    },

    setDatatableBookingsSolicitudesModificacion(state, payload) {
      state.dataDatatableBookingsSolicitudesModificacion = payload;
      state.dataDatatableBookingsSolicitudesModificacionFiltrada = payload;
    },

    setDataDatatableHistorialSolicitudModificacion(state, payload) {
      state.dataDatatableHistorialSolicitudModificacion = payload;
      state.dataDatatableHistorialSolicitudModificacionFiltrada = payload;
    },

    setDatatableBookingsCancelados(state, payload) {
      state.dataDatatableBookingsCancelados = payload;
      state.dataDatatableBookingsCanceladosFiltrada = payload;
    },

    setDataDatatableBookingsEmbarcados(state, payload) {
      state.dataDatatableBookingsEmbarcados = payload;
      state.dataDatatableBookingsEmbarcadosFiltrada = payload;
    },

    //tracking

    setDataDatatableTrackingBookings(state, payload) {
      state.dataDatatableTrackingBookings = payload;
    },

    setDataDatatableTrackingBookingsFiltered(state, payload) {
      state.dataDatatableTrackingBookingsFiltered = payload;
    },

    //

    setDataDatatableBookingsDeclaradosCancelados(state, payload) {
      state.dataDatatableBookingsDeclaradosCancelados = payload;
      state.dataDatatableBookingsDeclaradosCanceladosFiltrada = payload;
    },

    // ***************************************************************************
    // Perfil Administrador
    // ***************************************************************************
    // Bookings Solicitados

    setDataDatatableBookingsSolicitados(state, payload) {
      state.dataDatatableBookingsSolicitados = [];
      state.dataDatatableBookingsSolicitadosFiltrada = [];

      let dataAux = [];

      let seleccionados_aux = {
        deposito: {},
        via: {},
      };

      payload != null && payload.map((item) => {
        dataAux.push({
          seleccionados_aux: seleccionados_aux,
          data: item.data,
          data_complementaria: item.data_complementaria,
        });
      });

      state.dataDatatableBookingsSolicitados = dataAux;
      state.dataDatatableBookingsSolicitadosFiltrada = dataAux;
    },

    setDataDatatableBookingsSolicitadosActualizarSeleccion(state, payload) {
      if (payload.tipo == "deposito") {
        state.dataDatatableBookingsSolicitados[
          payload.index_fila
        ].seleccionados_aux.deposito = payload.data;
      } else if (payload.tipo == "via") {
        state.dataDatatableBookingsSolicitados[
          payload.index_fila
        ].seleccionados_aux.via = payload.data;
      }
    },

    // Bookings Declarados

    setDataDatatableBookingsDeclarados(state, payload) {
      state.dataDatatableBookingsDeclarados = payload;
      state.dataDatatableDeclaradosFiltrada = payload;
    },

    setDataAceptarBookingDeclarados(state, payload) {
      state.dataAceptarBookingDeclarados = payload;
    },
    // ***************************************************************************
    // Historiales
    // ***************************************************************************

    // Historial Por Confirmar
    setDataDatatableHistorialBookingPorConfirmar(state, payload) {
      state.dataDatatableHistorialBookingPorConfirmar = payload;
    },
    // Historial Confirmados
    setDataDatatableHistorialBookingConfirmados(state, payload) {
      state.dataDatatableHistorialBookingConfirmados = payload;
    },
    // Historial Solicitado
    setDataDatatableHistorialSolicitado(state, payload) {
      state.dataDatatableHistorialSolicitado = payload;
    },
    // Historial Declarado
    setDataDatatableHistorialDeclarado(state, payload) {
      state.dataDatatableHistorialDeclarado = payload;
    },
    // Historial Embarcado
    setDataDatatableHistorialEmbarcados(state, payload) {
      state.dataDatatableHistorialEmbarcados = payload;
    },
    // Historial Cancelado
    setDataDatatableHistorialCancelado(state, payload) {
      state.dataDatatableHistorialCancelado = payload;
    },
    // Historial Declarado Cancelado
    setDataDatatableHistorialDeclaradoCancelado(state, payload) {
      state.dataDatatableHistorialDeclaradoCancelado = payload;
    },
    // Historial Late Arrivals
    setDataDataTableHistorialLateArrivals(state, payload) {
      state.dataDataTableHistorialLateArrivals = payload;
    },

    // Servicios
    setDataServicios(state, payload) {
      state.dataDatatableServicios = payload;
      state.dataDatatableServiciosFiltrada = payload;
    },

    setFilterDataServicios(state, payload) {
      // state.dataDatatableServiciosFiltrada = state.dataDatatableServicios;
      state.dataDatatableServiciosFiltrada = payload;
    },

    setDataServiciosPuertos(state, payload) {
      state.dataDatatableServiciosPuertos = payload;
      state.dataDatatableServiciosPuertosFiltrada = payload;
    },

    setDataServiciosTransbordos(state, payload) {
      state.dataDatatableServiciosTransbordos = payload;
      state.dataDatatableServiciosTransbordosFiltrada = payload;
    },

    setDataServiciosTransbordosPuertos(state, payload) {
      state.dataDatatableServiciosTransbordosPuertos = payload;
      state.dataDatatableServiciosTransbordosPuertosFiltrada = payload;
    },

    setDataItinerarioTransbordos(state, payload) {
      state.dataDatatableItinerariosTransbordos = payload;
      state.dataDatatableItinerariosTransbordosFiltrada = payload;
    },

    setDataServiciosDetalles(state, payload) {
      state.dataDatatableServiciosDetalles = payload;
      state.dataDatatableServiciosDetallesFiltrada = payload;
    },

    //Tarifas
    setDataTarifasContratos(state, payload) {
      state.dataDatatableTarifasContratos = payload;
      state.dataDatatableTarifasContratosFiltrada = payload;
    },

    setDataTarifasAcuerdosLineas(state, payload) {
      state.dataDatatableTarifasAcuerdosLineas = payload;
      state.dataDatatableTarifasAcuerdosLineasFiltrada = payload;
    },
    setDataTarifasAcuerdosLineasInicial(state, payload) {
      state.dataDatatableTarifasAcuerdosLineasInicial = payload;
    },
    setDataTarifasAcuerdosClientesBase(state, payload) {
      state.dataDatatableTarifasAcuerdosClientesBase = payload;
      state.dataDatatableTarifasAcuerdosClientesBaseFiltrada = payload;
    },

    setDataTarifasAcuerdosClientes(state, payload) {
      state.dataDatatableTarifasAcuerdosClientes = payload;
      state.dataDatatableTarifasAcuerdosClientesFiltrada = payload;
    },

    setDataTarifasLineas(state, payload) {
      state.dataDatatableTarifasLineas = payload;
      state.dataDatatableTarifasLineasFiltrada = payload;
    },

    setDataTarifasDescuentosClientes(state, payload) {
      state.dataDatatableTarifasDescuentosClientes = payload;
      state.dataDatatableTarifasDescuentosClientesFiltrada = payload;
    },

    setFilterStateAcuerdosLineas(state, payload) {
      state.filterStateAcuerdosLineas = payload;
    },

    setFilterStateAcuerdosClientesBase(state, payload) {
      state.filterStateAcuerdosClientesBase = payload;
    },
    setFilterStateAcuerdosClientes(state, payload) {
      state.filterStateAcuerdosClientes = payload;
    },
    setFilterStateRecargos(state, payload) {
      state.filterStateRecargos = payload;
    },
    setDataDatatableTarifasRecargos(state, payload) {
      state.dataDatatableTarifasRecargos = payload;
    },

    setDataDatatableTarifasRecargosTypes(state, payload) {
      state.dataDatatableTarifasRecargosTypes = payload;
    },

    setShowModalAgregarTarifasRecargos(state, payload) {
      state.showModalAgregarTarifasRecargos = payload;
    },

    setShowModalFiltrosTarifasRecargos(state, payload) {
      state.showModalFiltrosTarifasRecargos = payload;
    },
    setShowModalEditarTarifasRecargo(state, payload) {
      state.showModalEditarTarifasRecargo = payload;
    },
    setShowModalEditarRecargosType(state, payload) {
      state.showModalEditarRecargosType = payload;
    },
    setShowModalVerDetalleTarifasRecargo(state, payload) {
      state.showModalVerDetalleTarifasRecargo = payload;
    },
    setShowModalRecargoType(state, payload) {
      state.showModalRecargoType = payload;
    },
    setRecargoTypeLoading(state, payload) {
      state.recargoTypeLoading = payload;
    },
    setDataEditarRecargoType(state, payload) {
      state.dataEditarRecargoType = payload;
    },
    setDataDuplicarRecargoType(state, payload) {
      state.dataDuplicarRecargoType = payload;
    },
    setDataRecargosAsociados(state, payload) {
      state.dataRecargosAsociados = payload;
    },
    setFiltroTypeRecharge(state, payload) {
      state.filtroTypeRecharge = payload;
    },
    setFiltroNaviera(state, payload) {
      state.filtroNaviera = payload;
    },
    setFiltroPol(state, payload) {
      state.filtroPol = payload;
    },
    setFiltroPod(state, payload) {
      state.filtroPod = payload;
    },
    setFiltroAtmosfera(state, payload) {
      state.filtroAtmosfera = payload;
    },
    setFiltroContainer(state, payload) {
      state.filtroContainer = payload;
    },
    setFiltroCommodity(state, payload) {
      state.filtroCommodity = payload;
    },
    setFiltroUnityPayment(state, payload) {
      state.filtroUnityPayment = payload;
    },
    setDataTarifasReporteTarifaEmbarcador(state, payload) {
      state.dataDatatableTarifasReporteTarifaEmbarcador = payload;
      state.dataDatatableTarifasReporteTarifaEmbarcadorFiltrada = payload;
    },
    //

    setIdAuxiliarBookingSeleccionado(state, payload) {
      state.idAuxiliarBookingSeleccionado = payload;
    },

    setIdAuxiliarServicioSeleccionado(state, payload) {
      state.idAuxiliarServicioSeleccionado = payload;
    },

    setIdAuxiliarServicioPuertoSeleccionado(state, payload) {
      state.idAuxiliarServicioPuertoSeleccionado = payload;
    },

    setIdAuxiliarTransbordoSeleccionado(state, payload) {
      state.idAuxiliarTransbordoSeleccionado = payload;
    },

    setIdAuxiliarItinerarioSeleccionado(state, payload) {
      state.idAuxiliarItinerarioSeleccionado = payload;
    },
    //Booking declarados
    setVisibleModalEditarBookingDeclarado(state, payload) {
      state.visibleModalEditarBookingDeclarado = payload;
    },

    setVisibleModalInformacionGeneral(state, payload) {
      state.visibleModalInformacionGeneral = payload;
    },

    setVisibleModalInformacionGeneralLateArrival(state, payload) {
      state.visibleModalInformacionGeneralLateArrival = payload;
    },
    setVisibleModalEditarLateArrival(state, payload) {
      state.visibleModalEditarLateArrival = payload;
    },
    // Agregar Late Arrival
    setVisibleModalAgregarLateArrival(state, payload) {
      state.visibleModalAgregarLateArrival = payload;
    },

    setVisibleModalRealizarSolicitudModificacion(state, payload) {
      state.visibleModalRealizarSolicitudModificacion = payload;
    },
    setVisibleModalEditarContrato(state, payload) {
      state.visibleModalEditarContrato = payload;
    },

    setVisibleModalTracking(state, payload) {
      state.visibleModalTracking = payload;
    },

    setVisibleModalAceptarBookingDeclarado(state, payload) {
      state.visibleModalAceptarBookingDeclarado = payload;
    },
    setVisibleModalAceptarBookingDeclaradoBuscarReserva(state, payload) {
      state.visibleModalAceptarBookingDeclaradoBuscarReserva = payload;
    },

    setVisibleModalCambiarServicioBooking(state, payload) {
      state.visibleModalCambiarServicioBooking = payload;
    },

    setVisibleModalCambiarServicioConfirmadoBooking(state, payload) {
      state.visibleModalCambiarServicioConfirmadoBooking = payload;
    },
    setVisibleModalDetalleSolicitudModificacion(state, payload) {
      state.visibleModalDetalleSolicitudModificacion = payload;
    },
    //Itinerarios
    setDataListarItinerarios(state, payload) {
      state.dataDatatableListarItinerarios = payload;
    },

    setDataListarItinerariosFiltrada(state, payload) {
      state.dataDatatableListarItinerariosFiltrada = payload;
    },

    limpiarDataListarItinerarios(state) {
      state.dataDatatableListarItinerariosFiltrada = state.dataDatatableListarItinerarios;
    },

    setDataListarItinerariosPuertosEmbarque(state, payload) {
      state.dataDatatableListarItinerariosPuertosEmbarque = payload;
      state.dataDatatableListarItinerariosPuertosEmbarqueFiltrada = payload;
    },

    //Busqueda Itinerarios
    setDataListarBuscarItinerarios(state, payload) {
      state.dataDatatableListarBusquedaItinerarios = payload;
      state.dataDatatableListarBusquedaItinerariosFiltrada = payload;
    },

    setDataFiltrosItinerarios(state, payload) {
      state.dataFiltrosItinerarios = payload;
    },

    setHasFilterItinerarios(state, payload) {
      state.hasFilterItinerarios = payload;
    },

    // Buscar Itinerarios
    setDataBuscarItinerarios(state, payload) {
      state.dataDatatableBuscarItinerario = payload;
      state.dataDatatableBuscarItinerarioFiltrada = payload;
    },

    //Late Arrivals
    setDataBookingsLateArrivals(state, payload) {
      state.dataDatatableBookingsLateArrivals = payload;
      state.dataDatatableBookingsLateArrivalsFiltrada = payload;
    },
    setDatatableDetalleLateArrivals(state, payload) {
      state.dataDatatableDetalleLateArrivals = payload;
      state.dataDatatableDetalleLateArrivalsFiltrada = payload;
    },

    // Variables auxiliares para abrir y cerrar modales
    setAuxModalBookingConfirmados(state, payload) {
      state.auxModalBookingConfirmados = payload;
    },

    setAuxModalBookingEmbarcado(state, payload) {
      state.auxModalBookingEmbarcado = payload;
    },
    // ***************************************************************************
    // Ventanas modales
    // ***************************************************************************
    setVisibleModalEmbarcarBooking(state, payload) {
      state.visibleModalEmbarcarBooking = payload;
    },

    setVisibleModalInformacionServicio(state, payload) {
      state.visibleModalInformacionServicio = payload;
    },

    setVisibleModalEditarServicio(state, payload) {
      state.visibleModalEditarServicio = payload;
    },

    setVisibleModalEditarServicioPuerto(state, payload) {
      state.visibleModalEditarServicioPuerto = payload;
    },

    setVisibleModalEditarServicioTransbordo(state, payload) {
      state.visibleModalEditarServicioTransbordo = payload;
    },

    setVisibleModalEditarServicioTransbordoPuerto(state, payload) {
      state.visibleModalEditarServicioTransbordoPuerto = payload;
    },
    setVisibleModalEditarItinerarioTransbordo(state, payload) {
      state.visibleModalEditarItinerarioTransbordo = payload;
    },

    setVisibleModalEditarItinerario(state, payload) {
      state.visibleModalEditarItinerario = payload;
    },

    setVisibleModalEditarItinerariosPuertosEmbarque(state, payload) {
      state.visibleModalEditarItinerariosPuertosEmbarque = payload;
    },

    setVisibleModalEditarItinerariosDestinosFinales(state, payload) {
      state.visibleModalEditarItinerariosDestinosFinales = payload;
    },

    setVisibleModalReservaBooking(state, payload) {
      state.visibleModalReservaBooking = payload;
    },

    setEstadoSolicitudReservaPlanificada(state, payload) {
      state.estadoSolicitudReservaPlanificada = payload;
    },

    setFormularioSolicitudNoPlanificada(state, payload) {
      state.formularioSolicitudNoPlanificada = payload;
    },

    //Modales Busqueda Itinerarios
    setVisibleModalDetallesItinerario(state, payload) {
      state.visibleModalDetallesItinerario = payload;
    },

    setVisibleModalReservarItinerario(state, payload) {
      state.visibleModalReservarItinerario = payload;
    },
    //

    setDataAnios(state, payload) {
      state.dataAnios = payload;
    },

    setDataSemanas(state, payload) {
      state.dataSemanas = payload;
    },

    setDataContenedores(state, payload) {
      state.dataContenedores = payload;
    },

    setDataPuertoDescarga(state, payload) {
      state.dataPuertoDescarga = payload;
    },

    setDataserviciosIntegrales(state, payload) {
      state.dataserviciosIntegrales = payload;
    },
    setShippers(state, payload) {
      state.shippers = payload;
    },
    setDataShippers(state, payload) {
      state.dataShippers = payload;
    },
    setDataShippersAddress(state, payload) {
      state.dataShippersAddress = payload;
    },
    setDataProducts(state, payload) {
      state.dataProducts = payload;
    },
    setDataMetodosPago(state, payload) {
      state.dataMetodosPago = payload;
    },
    setDataTarifaContrato(state, payload) {
      state.dataTarifaContrato = payload;
    },

    setListaProductosExportar(state, payload) {
      state.listaProductosExportar = payload;
    },

    setListaShipper(state, payload) {
      state.listaShippers = payload;
    },

    setListaDireccionesShipper(state, payload) {
      state.listaDireccionesShipper = payload;
    },

    setListaPacking(state, payload) {
      state.listaPacking = payload;
    },

    setListaConsignatarios(state, payload) {
      state.listaConsignatarios = payload;
    },
    setListaNotificados(state, payload) {
      state.listaNotificados = payload;
    },
    setListaAtmosferas(state, payload) {
      state.listaAtmosferas = payload;
    },

    setListaAnios(state, payload) {
      state.listaAnios = payload;
    },
    setListaAniosACopiar(state, payload) {
      state.listaAniosACopiar = payload;
    },
    setListaClientes(state, payload) {
      state.listaClientes = payload;
    },
    setListaClientesPap(state, payload) {
      state.listaClientesPap = payload;
    },
    setListaClientesApe(state, payload) {
      state.listaClientesApe = payload;
    },
    setListaServIntegral(state, payload) {
      state.listaServIntegral = payload;
    },


    setAbrirModalSeleccionarNave(state, payload) {
      state.abrirModalSeleccionarNave = payload;
    },

    setDataNaveSeleccionada(state, payload) {
      state.dataNaveSeleccionada = payload;
    },

    setVisibleModalSeleccionNave(state, payload) {
      state.visibleModalSeleccionNave = payload;
    },
    setVisibleModalSeleccionNaveActualizar(state, payload) {
      state.visibleModalSeleccionNaveActualizar = payload;
    },
    setVisibleModalReservaBookingAux(state, payload) {
      state.visibleModalReservaBookingAux = payload;
    },
    setVisibleModalSeleccionarTickeadosConfirmados(state, payload) {
      state.visibleModalSeleccionarTickeadosConfirmados = payload;
    },

    setVisibleModalSeleccionarTickeadosSolicitados(state, payload) {
      state.visibleModalSeleccionarTickeadosSolicitados = payload;
    },
    // Editar Acuerdo Linea
    setVisibleModalEditarSimpleAcuerdoLinea(state, payload) {
      state.visibleModalEditarSimpleAcuerdoLinea = payload;
    },
    setVisibleModalVerRecargosAsociados(state, payload) {
      state.visibleModalVerRecargosAsociados = payload;
    },
    setVisibleModalVerHistorialClientesBase(state, payload) {
      state.visibleModalVerHistorialClientesBase = payload;
    },
    setVisibleModalDuplicarAcuerdoLinea(state, payload) {
      state.visibleModalDuplicarAcuerdoLinea = payload;
    },
    setVisibleModalDuplicarContrato(state, payload) {
      state.visibleModalDuplicarContrato = payload;
    },
    // Editar Puerto Itinerarios
    setVisibleModalEditarPuertoItinerarios(state, payload) {
      state.visibleModalEditarPuertoItinerarios = payload;
    },
    // Actualizar y Filtrar
    setFormFiltroAcuerdoCliente(state, payload) {
      state.formFiltroAcuerdoCliente = payload;
    },

    setNuevoTransbordoAux(state, payload) {
      state.nuevoTransbordoAux = payload;
    },

    setPolAux(state, payload) {
      state.polAux = payload;
    },
    setNaveAux(state, payload) {
      state.naveAux = payload;
    },
    setViajeAux(state, payload) {
      state.viajeAux = payload;
    },
    setVisibleModalUtilizarReservaAnterior(state, payload) {
      state.visibleModalUtilizarReservaAnterior = payload;
    },

    //Tarifas
    setVisibleModalEditarTarifaContrato(state, payload) {
      state.visibleModalEditarTarifaContrato = payload;
    },

    setContadorMenuBookings(state, payload) {
      state.contadorMenuBookings = payload;
    },

    setReservaInformacionGeneralModal(state, payload) {
      state.reservaInformacionGeneralModal = payload;
    },
    setSelectCommodities(state, payload) {
      state.selectCommodities = payload;
    },
    setSelectAtmospheres(state, payload) {
      state.selectAtmospheres = payload;
    },
    setSelectContainers(state, payload) {
      state.selectContainers = payload;
    },
    setSelectContract(state, payload) {
      state.selectContract = payload;
    },
    setVisibleModalInformacionPlanificacionAnual(state, payload) {
      state.visibleModalInformacionPlanificacionAnual = payload;
    },

    setHabilitarEdicionMultipleAnual(state, payload) {
      state.habilitarEdicionMultipleAnual = payload;
    },

    setPuertosSeleccionadosPlanAnual(state, payload) {

      let dataAux = state.puertosSeleccionadosPlanAnual;
      state.puertosSeleccionadosPlanAnual = [];

      let { id_tab, estado } = payload;

      state.puertosSeleccionadosPlanAnual = dataAux;

      switch (id_tab) {

        case 1:
          state.puertosSeleccionadosPlanAnual.tab_1 = estado;
          break;

        case 2:
          state.puertosSeleccionadosPlanAnual.tab_2 = estado;
          break;

        case 3:
          state.puertosSeleccionadosPlanAnual.tab_3 = estado;
          break;

        case 4:
          state.puertosSeleccionadosPlanAnual.tab_4 = estado;
          break;

        case 5:
          state.puertosSeleccionadosPlanAnual.tab_5 = estado;
          break;


      }

    },

    setCheckPlanificacionAnual(state, payload) {
      state.checkPlanificacionAnual = payload;
    },

    setClearCheckPlanificacionAnual(state) {
      state.checkPlanificacionAnual = [];
    },

    setDataAnioSeleccionado(state, payload) {

      state.dataAnioSeleccionado = payload;

    },
    /********************************************************************************************/
    //**********************************Planificacion semanal ***********************************/
    setPSShowManageModal(state, payload) {
      state.psShowManageModal = payload;
    },

    setPSShowReportModal(state, payload) {
      state.psShowReportModal = payload;
    },

    setPSCreateMode(state, payload) {
      state.psCreateMode = payload;
    },

    setLista_productos(state, payload) {
      state.lista_productos = payload;
    },

    setLista_anios(state, payload) {
      state.lista_anios = payload;
    },
    setLista_clientes(state, payload) {
      state.lista_clientes = payload;
    },
    setLista_serv_integral(state, payload) {
      state.lista_serv_integral = payload;
    },

    setLista_contenedores(state, payload) {
      state.lista_contenedores = payload;
    },

    setLista_consignatarios(state, payload) {
      state.lista_consignatarios = payload;
    },

    setLista_puertos(state, payload) {
      state.lista_puertos = payload;
    },

    setNuevosConsolidadoMultiples(state, payload) {
      state.nuevosConsolidadoMultiples.push(payload);
    },

    setNuevosPuertosMultiplesAgregados(state, payload) {
      state.nuevosPuertosMultiplesAgregados.push(payload);
    },

    setNuevosPlanificacionAnualMultiple(state, payload) {
      state.nuevosPlanificacionAnualMultiple = payload;
    },

    setPuertoParaEliminarPlanificacionAnual(state, payload) {
      state.puertoParaEliminarPlanificacionAnual = payload;
    },

    setEliminacionConsolidado(state, payload) {
      state.eliminacionConsolidado = payload;
    },

    setEliminacionTab1(state, payload) {
      state.eliminacionTab1 = payload;
    },
    setEliminacionTab2(state, payload) {
      state.eliminacionTab2 = payload;
    },
    setEliminacionTab3(state, payload) {
      state.eliminacionTab3 = payload;
    },

    setEliminacionTab4(state, payload) {
      state.eliminacionTab4 = payload;
    },

    setProduct_selected(state, payload) {
      state.product_selected = payload;
    },
    setContainer_selected(state, payload) {
      state.container_selected = payload;
    },
    setAnnual_plan_id(state, payload) {
      state.annual_plan_id = payload;
    },

    setConfirmacionEliminarPuerto(state, payload) {
      state.confirmacionEliminarPuerto = payload;
    },

    setPSMultipleEditMode(state, payload) {
      state.psMultipleEditMode = payload;
    },

    setPSEnabledButtons(state, payload) {
      state.psEnabledButtons = payload;
    },

    setPSWeekTotals(state, payload) {
      state.psWeekTotals = payload;
    },

    setPSDataSelected(state, payload) {
      state.psDataSelected = payload;
    },

    setPSDataSelectedToDelete(state, payload) {
      state.psDataSelectedToDelete = payload;
    },

    setPSIsAdmin(state, payload) {
      state.psIsAdmin = payload;
    },

    setPSShowDetail(state, payload) {
      state.psShowDetail = payload;
    },

    setPSDetailPort(state, payload) {
      state.psDetailPort = payload;
    },

    setPSResumeDataTable(state, payload) {
      state.psResumeDataTable = payload;
    },

    filterPSResumeDataTableFiltrada(state, payload) {
      state.psResumeDataTableFiltrada = payload;
    },

    limpiarPSResumeDataTableResumenFiltrada(state) {
      state.psResumeDataTableFiltrada = state.psResumeDataTable;
    },

    setPSDataTable(state, payload) {
      state.psDataTable = payload;
    },

    filterPSDatatableFiltrada(state, payload) {
      state.psDataTableFiltrada = payload;
    },

    limpiarPSDatatableFiltrada(state) {
      state.psDataTableFiltrada = state.psDataTable;
    },

    setPSCurrentWeeks(state, payload) {
      state.psCurrentWeeks = payload;
    },

    setPSListaClientes(state, payload) {
      state.psListaClientes = payload;
    },
    setPSListaContenedores(state, payload) {
      state.psListaContenedores = payload;
    },
    setPSListaPuertos(state, payload) {
      state.psListaPuertos = payload;
    },
    setPSListaProductos(state, payload) {
      state.psListaProductos = payload;
    },

    setPSFiltroClientes(state, payload) {
      state.psFiltroClientes = payload;
    },
    setPSFiltroSemanas(state, payload) {
      state.psFiltroSemanas = payload;
    },
    setPSFiltroContenedores(state, payload) {
      state.psFiltroContenedores = payload;
    },
    setPSFiltroPuertos(state, payload) {
      state.psFiltroPuertos = payload;
    },
    setPSFiltroProductos(state, payload) {
      state.psFiltroProductos = payload;
    },
    setPSEnabledNotifications(state, payload) {
      state.psEnabledNotifications = payload;
    },

    async setPSNewPlanningsProducts(state, payload) {
      state.psEnabledButtons = false;
      const sql = await getProductosPorContenedor(payload);
      state.psNewPlanningProducts = sql.data.length > 0 ? sql.data : "";
      state.psEnabledButtons = true;
    },

    async setPSExistingPlanningsProducts(state, payload) {
      state.psEnabledButtons = false;
      const sql = await getProductosPorContenedor(payload.container_id);
      Vue.set(state.psExistingPlanningProducts, state.psProductsPrefix + payload.index, sql.data.length > 0 ? sql.data : "");
      state.psEnabledButtons = true;
    },

    async setPSAddedPlanningsProducts(state, payload) {
      state.psEnabledButtons = false;
      const sql = await getProductosPorContenedor(payload.container_id);
      Vue.set(state.psAddedPlanningProducts, state.psProductsPrefix + payload.index, sql.data.length > 0 ? sql.data : "");
      state.psEnabledButtons = true;
    },

    async setDataPlanificacionSemanalTabla(state) {
      state.dataPlanificacionSemanalTabla = await getPlanificacionSemanal();
    },

    async setDataPlanificacionAnualTabla(state) {
      const sql = await getPlanificacionAnual();
      state.dataPlanificacionAnualTabla = sql;
    },

    setPSFiltroAnios(state, payload) {
      state.psFiltroAnios = payload;
    },


    setYearsFilter(state, payload) {
      state.yearsFilter = payload;
    },
    setClienstFilter(state, payload) {
      state.clienstFilter = payload;
    },
    setContainersFilter(state, payload) {
      state.containersFilter = payload;
    },
    setProductsFilter(state, payload) {
      state.productsFilter = payload;
    },
    setServIntegralFilter(state, payload) {
      state.servIntegralFilter = payload;
    },
    setConsigneeFilter(state, payload) {
      state.consigneeFilter = payload;
    },
    setPortFilter(state, payload) {
      state.portFilter = payload;
    },
    setDataFiltradaPlanificacionAnual(state, payload) {
      state.dataFiltradaPlanificacionAnual = payload;
    },
    setPAShowReportModal(state, payload) {
      state.paShowReportModal = payload;
    },
    setShowModalBuscarReservaDeclaradoAceptar(state, payload) {
      state.showModalBuscarReservaDeclaradoAceptar = payload;
    },
    setShowModalBuscarReservaDeclaradoVerDetalle(state, payload) {
      state.showModalBuscarReservaDeclaradoVerDetalle = payload;
    },
    setShowModalBuscarReservaDeclaradoEditar(state, payload) {
      state.showModalBuscarReservaDeclaradoEditar = payload;
    },
    setGoTabSolicitudReserva(state, payload) {
      state.goTabSolicitudReserva = payload;
    },
    setPolEtdItinerary(state, payload) {
      state.polEtdItinerary = payload;
    },
    setStateIdDeclarados(state, payload) {
      state.stateIdDeclarados = payload;
    },
    setIdBookingItinerary(state, payload) {
      state.idBookingItinerary = payload;
    },

    setTariffRechargeDescription(state, payload) {
      state.tariffRechargeDescription = payload;
    },

    setLogistaasOptions(state, payload) {
      state.logistaasOptions = payload;
    },

    setLoadingTableConfirmados(state, payload) {
      state.loadingTableConfirmados = payload;
    },


    setIsBookingPlanned(state, payload) {
      state.isBookingPlanned = payload;
    },

    setShowModalCostosSIBooking(state, payload) {
      state.showModalCostosSIBooking = payload;
    },


    setLoadingItineraryTable(state, payload) {
      state.loadingItineraryTable = payload;
    },

    setLoadingTableCancelados(state, payload) {
      state.loadingTableCancelados = payload;
    },

    setLoadingTableCanceladosDeclarados(state, payload) {
      state.loadingTableCanceladosDeclarados = payload;
    },

    setLoadingTableItinerarySearch(state, payload) {
      state.loadingTableItinerarySearch = payload;
    },
    setShowModalfilterItinerary(state, payload) {
      state.showModalfilterItinerary = payload;
    },

    setMethodPay(state, payload) {
      state.methodPay = payload;
    },

    setShowModalfilterTariffLines(state, payload) {
      state.showModalfilterTariffLines = payload;
    },
    setShowModalImportRecharges(state, payload) {
      state.showModalImportRecharges = payload;
    },
    setShowModalRechargesNavieras(state, payload) {
      state.showModalRechargesNavieras = payload;
    },
    setDataDataTableQuotationImporter(state, payload) {
      state.dataDataTableQuotationImporter = payload;
    },
    setDataDataTableQuotationImporterLoading(state, payload) {
      state.dataDataTableQuotationImporterLoading = payload;
    },
    setShowDataTableQuotationImporterModal(state, payload) {
      state.showDataTableQuotationImporterModal = payload;
    },

    setShowModalTiposExtraCosto(state, payload) {
      state.showModalTiposExtraCosto = payload;
    },

    async setDataExtraCostosTipos(state) {

      // const { data } = await getTiposExtraCostos();
      const data = await getTiposExtraCostos();
      state.dataExtraCostosTipos = data;
      state.dataExtraCostosTiposBase = data;

    },

    async setDataNumeroContenedor(state, payload) {

      state.dataNumeroContenedor = await validarNumeroContenedor(payload);

    },

    setFiltroDataExtraCostosTipos(state, payload) {
      state.dataExtraCostosTipos = payload;
    },

    setLimpiarFiltroDataExtraCostosTipos(state) {
      state.dataExtraCostosTipos = state.dataExtraCostosTiposBase;
    },


    async setDataExtraCostos(state, payload) {

      const { id_booking_itinerary, booking_number } = payload;

      const { data, unidad_pago, data_select_container } = await getExtraCostos({ id_booking_itinerary, booking_number });

      state.dataExtraCostos = data;
      state.dataExtraCostosBase = data;
      state.dataUnidadPago = unidad_pago;
      state.dataSelectContainer = data_select_container;

    },

    async setDataProveedores(state, payload) {
      const data = await GetDataProveedores( payload );
      state.dataProveedores = data;
    },


    async setFilterDataExtraCostos(state, payload) {

      const { data } = await getExtraCostos(payload);
      state.dataExtraCostos = data;
    },

    async resetFilterDataExtraCostos(state) {
      state.dataExtraCostos = state.dataExtraCostosBase;
    },


    setShowModalExtraCosto(state, payload) {
      state.showModalExtraCosto = payload;
    },

    setFormasPagoLista(state, payload) {
      state.formasPagoLista = payload;
    },

    setTipoUnidadLista(state, payload) {
      state.tipoUnidadLista = payload;
    },

    setTiposExtraCostos(state, payload) {
      state.tiposExtraCostos = payload;
    },

    setTiposMonedasLista(state, payload) {
      state.tiposMonedasLista = payload;
    },

    setTiposCargosLista(state, payload) {
      state.tiposCargosLista = payload;
    },
    setShowModalAddValueDictionary(state, payload) {
      state.showModalAddValueDictionary = payload;
    },

    //descuentos clientes
    setShowModalCustomerDiscountsRecharges(state, payload) {
      state.showModalCustomerDiscountsRecharges = payload;
    },

    //tarifas de lineas
    setShowModalTariffLinesRecharges(state, payload) {
      state.showModalTariffLinesRecharges = payload;
    },
    setRechargeTypes(state, payload) {
      state.rechargeTypes = payload;
    },

    setLoadingAdmExtraCostos(state, payload) {
      state.loadingAdmExtraCostos = payload;
    },
    setDataPlantsProveedores(state, payload) {
      state.dataPlantsProveedores = payload;
    },
    setCurrentFiltersPlanificacionSemanal(state, payload) {
      state.currentFiltersPlanificacionSemanal = payload;
    },
    setVisibleModalAgregarBlNumber(state, payload) {
      state.visibleModalAgregarBlNumber = payload;
    },
  },

  // 1
  actions: {
    // ***************************************************************************
    //Buscador
    // ***************************************************************************
    actionSetBlSearchCarrierBookingNumber({ commit }, data) {
      commit("setBlSearchCarrierBookingNumber", data);
    },

    actionSetDataResultadoBooking({ commit }, data) {
      commit("setDataResultadoBooking", data);
    },

    actionSetDataResultadoContainers({ commit }, data) {
      commit("setDataResultadoContainers", data);
    },

    actionSetDataResultadoBillLadings({ commit }, data) {
      commit("setDataResultadoBillLadings", data);
    },
    // ***************************************************************************
    //Filtros Bookings
    // ***************************************************************************
    actionSetDataListaCliente({ commit }, data) {
      commit("setDataListaCliente", data);
    },

    actionSetDataListaClienteLA({ commit }, data) {
      commit("setDataListaClienteLA", data);
    },

    actionSetDataListaNaviera({ commit }, data) {
      commit("setDataListaNaviera", data);
    },

    actionSetDataListaNavierasNoUCC({ commit }, data) {
      commit("setDataListaNavierasNoUCC", data);
    },

    actionSetDataListaTipo({ commit }, data) {
      commit("setDataListaTipo", data);
    },

    actionSetDataListaServicios({ commit }, data) {
      commit("setDataListaServicios", data);
    },

    actionSetDataListaPOD({ commit }, data) {
      commit("setDataListaPOD", data);
    },

    actionSetDataListaPodLA({ commit }, data) {
      commit("setDataListaPodLA", data);
    },

    actionSetDataListaComercial({ commit }, data) {
      commit("setDataListaComercial", data);
    },

    actionSetDataListaComercialLA({ commit }, data) {
      commit("setDataListaComercialLA", data);
    },

    actionSetDataListaNave({ commit }, data) {
      commit("setDataListaNave", data);
    },

    actionSetDataListaSemana({ commit }, data) {
      commit("setDataListaSemana", data);
    },

    actionSetDataListaSemanaLA({ commit }, data) {
      commit("setDataListaSemanaLA", data);
    },

    actionSetDataListaPOL({ commit }, data) {
      commit("setDataListaPOL", data);
    },

    actionSetDataListaProducto({ commit }, data) {
      commit("setDataListaProducto", data);
    },
    actionSetDataListaEstado({ commit }, data) {
      commit("setDataListaEstado", data);
    },
    actionSetDataListaSI({ commit }, data) {
      commit("setDataListaSI", data);
    },
    actionSetDataListaTipoSI({ commit }, data) {
      commit("setDataListaTipoSI", data);
    },
    actionSetDataListaDestinos({ commit }, data) {
      commit("setDataListaDestinos", data);
    },
    //Actualizar Solicitud
    actionSetDataMotivo({ commit }, data) {
      commit("setDataMotivo", data);
    },
    actionSetCurrentFiltersBookings({ commit }, data) {
      commit("setCurrentFiltersBookings", data);
    },
    actionSetFlagFiltersBookings({ commit }, data) {
      commit("setFlagFiltersBookings", data);
    },
    actionSetFlagFiltersPlanificacionSemanal({ commit }, data) {
      commit("setFlagFiltersPlanificacionSemanal", data);
    },
    actionSetDataFormAgregarReservaFromItinerary({ commit }, data) {
      commit("setDataFormAgregarReservaFromItinerary", data);
    },

    //Filtros Itinerarios
    // actionSetDataFiltroNaves({ commit }, data) {
    //   commit("setDataFiltroNaves", data);
    // },

    // actionSetDataFiltroNavieras({ commit }, data) {
    //   commit("setDataFiltroNavieras", data);
    // },

    // actionSetDataFiltroServicios({ commit }, data) {
    //   commit("setDataFiltroServicios", data);
    // },

    actionSetDataFiltroSemanas({ commit }, data) {
      commit("setDataFiltroSemanas", data);
    },

    actionSetDataFiltroPols({ commit }, data) {
      commit("setDataFiltroPols", data);
    },

    actionSetDataFiltroAnios({ commit }, data) {
      commit("setDataFiltroAnios", data);
    },
    //////////////////////////////////////////////////
    // Filtros Bookings Embarcados
    actionSetDataListaAnio({ commit }, data) {
      commit("setDataListaAnio", data);
    },

    actionSetDataListaAnioLA({ commit }, data) {
      commit("setDataListaAnioLA", data);
    },

    actionSetDataListaServicioIntegral({ commit }, data) {
      commit("setDataListaServicioIntegral", data);
    },

    actionSetDataListaNombreServicios({ commit }, data) {
      commit("setDataListaNombreServicios", data);
    },

    //////////////////////////////////////////////////
    // Filtros Bookings Cancelados

    /////////////////////////////////////////////////
    // Filtros Bookings Declarados Cancelados

    // Fin Filtros Bookings

    // Vista Admin

    // Bookings Solicitados
    actionFilterDataDatatableBookingsSolicitados({ commit }, data) {
      commit("filterDataDatatableBookingsSolicitados", data);
    },
    actionLimpiarDataDatatableBookingsSolicitados({ commit }, data) {
      commit("limpiarDataDatatableBookingsSolicitados", data);
    },
    // Bookings Declarados
    actionFilterDataDatatableBookingsDeclarados({ commit }, data) {
      commit("filterDataDatatableBookingsDeclarados", data);
    },
    actionLimpiarDataDatatableBookingsDeclarados({ commit }, data) {
      commit("limpiarDataDatatableBookingsDeclarados", data);
    },
    // Fin Vista Admin

    // Filter Bookings Por Aceptar
    actionFilterDataVerMisBookingsPorAceptar({ commit }, data) {
      commit("filterDataVerMisBookingsPorAceptar", data);
    },
    actionLimpiarDataVerMisBookingsPorAceptar({ commit }, data) {
      commit("limpiarDataVerMisBookingsPorAceptar", data);
    },

    // Filter Bookings Por Confirmar
    actionFilterDataBookingsPorConfirmar({ commit }, data) {
      commit("filterDataBookingsPorConfirmar", data);
    },

    actionLimpiarDataBookingsPorConfirmar({ commit }, data) {
      commit("limpiarDataBookingsPorConfirmar", data);
    },

    // Filter Bookings Confirmados

    actionFilterDataBookingsConfirmados({ commit }, data) {
      commit("filterDataBookingsConfirmados", data);
    },
    actionLimpiarDataBookingsConfirmados({ commit }, data) {
      commit("limpiarDataBookingsConfirmados", data);
    },

    // Filter Solicitud Modificacion
    actionFilterDataSolicitudModificado({ commit }, data) {
      commit("filterDataSolicitudModificado", data);
    },

    actionLimpiarDataSolicitudModificado({ commit }, data) {
      commit("limpiarDataSolicitudModificado", data);
    },

    actionFilterDataHistorialSolicitudModificado({ commit }, data) {
      commit("filterDataHistorialSolicitudModificado", data);
    },

    actionLimpiarDataHistorialSolicitudModificado({ commit }, data) {
      commit("limpiarDataHistorialSolicitudModificado", data);
    },

    // Bookings Embarcados

    actionFilterDataEmbarcado({ commit }, data) {
      commit("filterDataEmbarcado", data);
    },

    actionLimpiarDataEmbarcado({ commit }, data) {
      commit("limpiarDataEmbarcado", data);
    },
    // Bookings Cancelados
    actionFilterDataCancelados({ commit }, data) {
      commit("filterDataCancelados", data);
    },

    actionLimpiarDataCancelados({ commit }, data) {
      commit("limpiarDataCancelados", data);
    },

    actionLimpiarDataServicios({ commit }, data) {
      commit("limpiarDataServicios", data);
    },
    // Bookings Declarados Cancelados

    actionFilterDataDeclaradosCancelados({ commit }, data) {
      commit("filterDataDeclaradosCancelados", data);
    },

    actionLimpiarDataDeclaradosCancelados({ commit }, data) {
      commit("limpiarDataDeclaradosCancelados", data);
    },

    // Filtros Itinerarios

    actionFilterDataListarItinerarios({ commit }, data) {
      commit("filterDataListarItinerarios", data);
    },

    // Filtros Buscar Itinerarios
    actionFilterDataListarBusquedaItinerarios({ commit }, data) {
      commit("filterDataListarBusquedaItinerarios", data);
    },
    actionLimpiarDataListarBusquedaItinerarios({ commit }, data) {
      commit("limpiarDataListarBusquedaItinerarios", data);
    },

    // Filtros Late Arrivals

    actionFilterDataBookingsLateArrivals({ commit }, data) {
      commit("filterDataBookingsLateArrivals", data);
    },

    actionLimpiarDataBookingsLateArrivals({ commit }, data) {
      commit("limpiarDataBookingsLateArrivals", data);
    },

    // Filtros Tarifas
    // Filtros Contratos
    actionFilterDataTarifasContratos({ commit }, data) {
      commit("filterDataTarifasContratos", data);
    },

    actionLimpiarDataTarifasContratos({ commit }, data) {
      commit("limpiarDataTarifasContratos", data);
    },
    // Filtro Acuerdo Lineas
    actionFilterDataAcuerdosLineas({ commit }, data) {
      commit("filterDataAcuerdosLineas", data);
    },

    actionLimpiarDataAcuerdosLineas({ commit }, data) {
      commit("limpiarDataAcuerdosLineas", data);
    },
    // Filtro Tarifas de Lineas
    actionFilterDataTarifasLineas({ commit }, data) {
      commit("filterDataTarifasLineas", data);
    },
    actionLimpiarDataTarifasLineas({ commit }, data) {
      commit("limpiarDataTarifasLineas", data);
    },

    // Información para data tables
    actionSetDatatableVerMisBookingsPorAceptar({ commit }, data) {
      commit("setDatatableVerMisBookingsPorAceptar", data);
    },
    // actionSetDataVerBookingsPorAceptar({ commit }, data) {
    //   commit("setDataVerBookingsPorAceptar", data);
    // },
    // *************************************************************
    // Variables Auxiliares
    // *************************************************************
    actionSetIdAuxiliarBookingSeleccionado({ commit }, data) {
      commit("setIdAuxiliarBookingSeleccionado", data);
    },
    actionSetIdAuxiliarServicioSeleccionado({ commit }, data) {
      commit("setIdAuxiliarServicioSeleccionado", data);
    },
    actionSetIdAuxiliarServicioPuertoSeleccionado({ commit }, data) {
      commit("setIdAuxiliarServicioPuertoSeleccionado", data);
    },
    actionSetIdAuxiliarTransbordoSeleccionado({ commit }, data) {
      commit("setIdAuxiliarTransbordoSeleccionado", data);
    },
    actionSetIdAuxiliarItinerarioSeleccionado({ commit }, data) {
      commit("setIdAuxiliarItinerarioSeleccionado", data);
    },
    //Booking declarados
    actionSetVisibleModalEditarBookingDeclarado({ commit }, data) {
      commit("setVisibleModalEditarBookingDeclarado", data);
    },
    // Ventana Detalle
    actionSetVisibleModalInformacionGeneral({ commit }, data) {
      commit("setVisibleModalInformacionGeneral", data);
    },
    actionSetVisibleModalInformacionGeneralLateArrival({ commit }, data) {
      commit("setVisibleModalInformacionGeneralLateArrival", data);
    },
    actionSetVisibleModalEditarLateArrival({ commit }, data) {
      commit("setVisibleModalEditarLateArrival", data);
    },
    // Agregar Late Arrival
    actionSetVisibleModalAgregarLateArrival({ commit }, data) {
      commit("setVisibleModalAgregarLateArrival", data);
    },
    actionSetVisibleModalRealizarSolicitudModificacion({ commit }, data) {
      commit("setVisibleModalRealizarSolicitudModificacion", data);
    },
    actionSetVisibleModalEditarContrato({ commit }, data) {
      commit("setVisibleModalEditarContrato", data);
    },

    actionSetVisibleModalTracking({ commit }, data) {
      commit("setVisibleModalTracking", data);
    },
    actionSetVisibleModalAceptarBookingDeclarado({ commit }, data) {
      commit("setVisibleModalAceptarBookingDeclarado", data);
    },

    actionSetVisibleModalAceptarBookingDeclaradoBuscarReserva({ commit }, data) {
      commit("setVisibleModalAceptarBookingDeclaradoBuscarReserva", data);
    },
    actionSetVisibleModalCambiarServicioBooking({ commit }, data) {
      commit("setVisibleModalCambiarServicioBooking", data);
    },

    actionSetVisibleModalCambiarServicioConfirmadoBooking({ commit }, data) {
      commit("setVisibleModalCambiarServicioConfirmadoBooking", data);
    },

    actionSetVisibleModalDetalleSolicitudModificacion({ commit }, data) {
      commit("setVisibleModalDetalleSolicitudModificacion", data);
    },

    //tarifas
    actionSetVisibleModalEditarTarifaContrato({ commit }, data) {
      commit("setVisibleModalEditarTarifaContrato", data);
    },

    // Fin Servicio Booking

    actionSetDatatableBookingsSolicitudesModificacion({ commit }, data) {
      commit("setDatatableBookingsSolicitudesModificacion", data);
    },

    actionSetDataDatatableHistorialSolicitudModificacion({ commit }, data) {
      commit("setDataDatatableHistorialSolicitudModificacion", data);
    },

    actionSetDatatableBookingsCancelados({ commit }, data) {
      commit("setDatatableBookingsCancelados", data);
    },

    actionSetDataDatatableBookingsEmbarcados({ commit }, data) {
      commit("setDataDatatableBookingsEmbarcados", data);
    },

    //tracking

    actionSetDataDatatableTrackingBookings({ commit }, data) {
      commit("setDataDatatableTrackingBookings", data);
    },

    actionSetDataDatatableTrackingBookingsFiltered({ commit }, data) {
      commit("setDataDatatableTrackingBookingsFiltered", data);
    },

    //

    actionSetDataDatatableBookingsDeclaradosCancelados({ commit }, data) {
      commit("setDataDatatableBookingsDeclaradosCancelados", data);
    },

    // Perfil Administrador

    // Bookings Solicitados
    actionSetDataDatatableBookingsSolicitados({ commit }, data) {
      commit("setDataDatatableBookingsSolicitados", data);
    },

    actionSetDataDatatableBookingsSolicitadosActualizarSeleccion({ commit }, data) {
      commit("setDataDatatableBookingsSolicitadosActualizarSeleccion", data);
    },

    // Bookings Declarados
    actionSetDataDatatableBookingsDeclarados({ commit }, data) {
      commit("setDataDatatableBookingsDeclarados", data);
    },
    // Traer Lista de Servicios para Aceptar un Booking Declarado
    actionSetDataAceptarBookingDeclarados({ commit }, data) {
      commit("setDataAceptarBookingDeclarados", data);
    },

    //

    // ***************************************************************************
    // Historiales
    // ***************************************************************************

    // Historial Por Confirmar
    actionSetDataDatatableHistorialBookingPorConfirmar({ commit }, data) {
      commit("setDataDatatableHistorialBookingPorConfirmar", data);
    },
    // Historial Confirmado
    actionSetDataDatatableHistorialBookingConfirmados({ commit }, data) {
      commit("setDataDatatableHistorialBookingConfirmados", data);
    },
    // Historial Declarado
    actionSetDataDatatableHistorialDeclarado({ commit }, data) {
      commit("setDataDatatableHistorialDeclarado", data);
    },
    // Historial Solicitado
    actionSetDataDatatableHistorialSolicitado({ commit }, data) {
      commit("setDataDatatableHistorialSolicitado", data);
    },
    // Historial Embarcado
    actionSetDataDatatableHistorialEmbarcados({ commit }, data) {
      commit("setDataDatatableHistorialEmbarcados", data);
    },
    // Historial Cancelado
    actionSetDataDatatableHistorialCancelado({ commit }, data) {
      commit("setDataDatatableHistorialCancelado", data);
    },
    // Historial Declarado Cancelado
    actionSetDataDatatableHistorialDeclaradoCancelado({ commit }, data) {
      commit("setDataDatatableHistorialDeclaradoCancelado", data);
    },
    // Historial Late Arrivals
    actionSetDataDataTableHistorialLateArrivals({ commit }, data) {
      commit("setDataDataTableHistorialLateArrivals", data);
    },
    // Servicios
    actionSetDataServicios({ commit }, data) {
      commit("setDataServicios", data);
    },
    actionSetFilterDataServicio({ commit }, data) {
      commit("setFilterDataServicios", data);
    },
    actionSetDataServiciosPuertos({ commit }, data) {
      commit("setDataServiciosPuertos", data);
    },
    actionSetDataServiciosTransbordos({ commit }, data) {
      commit("setDataServiciosTransbordos", data);
    },
    actionSetDataServiciosTransbordosPuertos({ commit }, data) {
      commit("setDataServiciosTransbordosPuertos", data);
    },
    actionSetDataItinerarioTransbordos({ commit }, data) {
      commit("setDataItinerarioTransbordos", data);
    },
    actionSetDataServiciosDetalles({ commit }, data) {
      commit("setDataServiciosDetalles", data);
    },
    actionSetDatatableBookingsPorConfirmar({ commit }, data) {
      commit("setDatatableBookingsPorConfirmar", data);
    },
    actionSetDatatableBookingsConfirmados({ commit }, data) {
      commit("setDatatableBookingsConfirmados", data);
    },
    //Itinerarios
    actionSetDataListarItinerarios({ commit }, data) {
      commit("setDataListarItinerarios", data);
    },
    actionSetDataListarItinerariosFiltrada({ commit }, data) {
      commit("setDataListarItinerariosFiltrada", data);
    },
    actionLimpiarDataListarItinerarios({ commit }, data) {
      commit("limpiarDataListarItinerarios", data);
    },
    actionSetDataListarItinerariosPuertosEmbarque({ commit }, data) {
      commit("setDataListarItinerariosPuertosEmbarque", data);
    },
    actionSetDataItinerariosServiciosPuertosTransbordos({ commit }, data) {
      commit("setDataItinerariosServiciosPuertosTransbordos", data);
    },
    //Busqueda Itinerarios
    actionSetDataListarBusquedaItinerarios({ commit }, data) {
      commit("setDataListarBuscarItinerarios", data);
    },
    actionSetDataFiltrosItinerarios({ commit }, data) {
      commit("setDataFiltrosItinerarios", data);
    },
    actionSetHasFilterItinerarios({ commit }, data) {
      commit("setHasFilterItinerarios", data);
    },
    actionSetDataBuscarItinerarios({ commit }, data) {
      commit("setDataBuscarItinerarios", data);
    },
    actionSetEstadoListarItinerarios({ commit }, data) {
      commit("setEstadoListarItinerarios", data);
    },
    //Tarifas
    actionSetDataListarTarifasContratos({ commit }, data) {
      commit("setDataTarifasContratos", data);
    },
    actionSetDataListarTarifasAcuerdosLineas({ commit }, data) {
      commit("setDataTarifasAcuerdosLineas", data);
    },
    actionSetDataListarTarifasAcuerdosLineasInicial({ commit }, data) {
      commit("setDataTarifasAcuerdosLineasInicial", data);
    },
    actionSetDataListarTarifasAcuerdosClientesBase({ commit }, data) {
      commit("setDataTarifasAcuerdosClientesBase", data);
    },
    actionSetDataListarTarifasAcuerdosClientes({ commit }, data) {
      commit("setDataTarifasAcuerdosClientes", data);
    },
    actionSetDataListarTarifasLineas({ commit }, data) {
      commit("setDataTarifasLineas", data);
    },
    actionSetDataListarTarifasDescuentosClientes({ commit }, data) {
      commit("setDataTarifasDescuentosClientes", data);
    },
    actionSetFilterStateAcuerdosLineas({ commit }, data) {
      commit("setFilterStateAcuerdosLineas", data);
    },
    actionSetFilterStateAcuerdosClientesBase({ commit }, data) {
      commit("setFilterStateAcuerdosClientesBase", data);
    },
    actionSetDataDatatableTarifasRecargos({ commit }, data) {
      commit("setDataDatatableTarifasRecargos", data);
    },
    actionSetDataDatatableTarifasRecargosTypes({ commit }, data) {
      commit("setDataDatatableTarifasRecargosTypes", data);
    },
    actionSetShowModalAgregarTarifasRecargos({ commit }, data) {
      commit("setShowModalAgregarTarifasRecargos", data);
    },
    actionSetShowModalFiltrosTarifasRecargos({ commit }, data) {
      commit("setShowModalFiltrosTarifasRecargos", data);
    },
    actionSetShowModalEditarTarifasRecargo({ commit }, data) {
      commit("setShowModalEditarTarifasRecargo", data);
    },
    actionShowModalVerDetalleTarifasRecargo({ commit }, data) {
      commit("setShowModalVerDetalleTarifasRecargo", data);
    },
    actionSetShowModalEditarRecargosType({ commit }, data) {
      commit("setShowModalEditarRecargosType", data);
    },
    actionSetRecargoTypeLoading({ commit }, data) {
      commit("setRecargoTypeLoading", data);
    },
    actionSetDataEditarRecargoType({ commit }, data) {
      commit("setDataEditarRecargoType", data);
    },
    actionSetDataDuplicarRecargoType({ commit }, data) {
      commit("setDataDuplicarRecargoType", data);
    },
    actionSetDataRecargosAsociados({ commit }, data) {
      commit("setDataRecargosAsociados", data);
    },
    actionSetShowModalRecargoType({ commit }, data) {
      commit("setShowModalRecargoType", data);
    },
    actionSetFiltroTypeRecharge({ commit }, data) {
      commit("setFiltroTypeRecharge", data);
    },
    actionSetFiltroNaviera({ commit }, data) {
      commit("setFiltroNaviera", data);
    },
    actionSetFiltroPol({ commit }, data) {
      commit("setFiltroPol", data);
    },
    actionSetFiltroPod({ commit }, data) {
      commit("setFiltroPod", data);
    },
    actionSetFiltroAtmosfera({ commit }, data) {
      commit("setFiltroAtmosfera", data);
    },
    actionSetFiltroContainer({ commit }, data) {
      commit("setFiltroContainer", data);
    },
    actionSetFiltroCommodity({ commit }, data) {
      commit("setFiltroCommodity", data);
    },
    actionSetFiltroUnityPayment({ commit }, data) {
      commit("setFiltroUnityPayment", data);
    },
    actionSetFilterStateAcuerdosClientes({ commit }, data) {
      commit("setFilterStateAcuerdosClientes", data);
    },
    actionSetFilterStateRecargos({ commit }, data) {
      commit("setFilterStateRecargos", data);
    },
    actionSetDataListarTarifasReporteTarifaEmbarcador({ commit }, data) {
      commit("setDataTarifasReporteTarifaEmbarcador", data);
    },
    //Late Arrivals
    actionSetDataBookingsLateArrivals({ commit }, data) {
      commit("setDataBookingsLateArrivals", data);
    },
    actionSetDatatableDetalleLateArrivals({ commit }, data) {
      commit("setDatatableDetalleLateArrivals", data);
    },
    // Variables auxiliares para abrir y cerrar modales
    actionSetAuxModalBookingConfirmados({ commit }, data) {
      commit("setAuxModalBookingConfirmados", data);
    },
    actionSetAuxModalBookingEmbarcado({ commit }, data) {
      commit("setAuxModalBookingEmbarcado", data);
    },
    /* Ventanas modales */
    actionSetVisibleModalEmbarcarBooking({ commit }, data) {
      commit("setVisibleModalEmbarcarBooking", data);
    },
    actionSetVisibleModalInformacionServicio({ commit }, data) {
      commit("setVisibleModalInformacionServicio", data);
    },
    actionSetVisibleModalEditarServicio({ commit }, data) {
      commit("setVisibleModalEditarServicio", data);
    },
    actionSetVisibleModalEditarServicioPuerto({ commit }, data) {
      commit("setVisibleModalEditarServicioPuerto", data);
    },
    actionSetVisibleModalEditarServicioTransbordo({ commit }, data) {
      commit("setVisibleModalEditarServicioTransbordo", data);
    },
    actionSetVisibleModalEditarServicioTransbordoPuerto({ commit }, data) {
      commit("setVisibleModalEditarServicioTransbordoPuerto", data);
    },
    actionSetVisibleModalEditarItinerarioTransbordo({ commit }, data) {
      commit("setVisibleModalEditarItinerarioTransbordo", data);
    },
    actionSetVisibleModalEditarItinerario({ commit }, data) {
      commit("setVisibleModalEditarItinerario", data);
    },
    actionSetVisibleModalEditarItinerariosPuertosEmbarque({ commit }, data) {
      commit("setVisibleModalEditarItinerariosPuertosEmbarque", data);
    },
    actionSetVisibleModalEditarItinerariosDestinosFinales({ commit }, data) {
      commit("setVisibleModalEditarItinerariosDestinosFinales", data);
    },
    actionSetVisibleModalReservaBooking({ commit }, data) {
      commit("setVisibleModalReservaBooking", data);
    },
    actionSetEstadoSolicitudReservaPlanificada({ commit }, data) {
      commit("setEstadoSolicitudReservaPlanificada", data);
    },
    actionSetFormularioSolicitudNoPlanificada({ commit }, data) {
      commit("setFormularioSolicitudNoPlanificada", data);
    },
    // Modales Busqueda Itinerarios
    actionSetVisibleModalDetallesItinerario({ commit }, data) {
      commit("setVisibleModalDetallesItinerario", data);
    },
    actionSetVisibleModalReservarItinerario({ commit }, data) {
      commit("setVisibleModalReservarItinerario", data);
    },
    //
    actionSetDataAnios({ commit }, data) {
      commit("setDataAnios", data);
    },
    actionSetDataSemanas({ commit }, data) {
      commit("setDataSemanas", data);
    },
    actionSetDataContenedores({ commit }, data) {
      commit("setDataContenedores", data);
    },
    actionSetDataPuertoDescarga({ commit }, data) {
      commit("setDataPuertoDescarga", data);
    },
    actionSetDataserviciosIntegrales({ commit }, data) {
      commit("setDataserviciosIntegrales", data);
    },
    actionSetDataShippers({ commit }, data) {
      commit("setDataShippers", data);
    },
    actionSetShippers({ commit }, data) {
      commit("setShippers", data);
    },
    actionSetDataShippersAddress({ commit }, data) {
      commit("setDataShippersAddress", data);
    },
    actionSetDataProducts({ commit }, data) {
      commit("setDataProducts", data);
    },
    actionSetDataMetodosPago({ commit }, data) {
      commit("setDataMetodosPago", data);
    },
    actionSetDataTarifaContrato({ commit }, data) {
      commit("setDataTarifaContrato", data);
    },
    actionSetListaProductosExportar({ commit }, data) {
      commit("setListaProductosExportar", data);
    },
    actionSetListaShipper({ commit }, data) {
      commit("setListaShipper", data);
    },
    actionSetListaDireccionesShipper({ commit }, data) {
      commit("setListaDireccionesShipper", data);
    },
    actionSetListaPacking({ commit }, data) {
      commit("setListaPacking", data);
    },
    actionSetListaConsignatarios({ commit }, data) {
      commit("setListaConsignatarios", data);
    },
    actionSetListaNotificados({ commit }, data) {
      commit("setListaNotificados", data);
    },
    actionSetListaAtmosferas({ commit }, data) {
      commit("setListaAtmosferas", data);
    },
    actionSetListaAnios({ commit }, data) {
      commit("setListaAnios", data);
    },
    actionSetListaAniosACopiar({ commit }, data) {
      commit("setListaAniosACopiar", data);
    },
    actionSetListaClientes({ commit }, data) {
      commit("setListaClientes", data);
    },
    actionSetListaClientesPap({ commit }, data) {
      commit("setListaClientesPap", data);
    },
    actionSetListaClientesApe({ commit }, data) {
      commit("setListaClientesApe", data);
    },
    actionSetListaServIntegral({ commit }, data) {
      commit("setListaServIntegral", data);
    },
    actionSetAbrirModalSeleccionarNave({ commit }, data) {
      commit("setAbrirModalSeleccionarNave", data);
    },
    actionSetDataNaveSeleccionada({ commit }, data) {
      commit("setDataNaveSeleccionada", data);
    },
    actionSetVisibleModalSeleccionNave({ commit }, data) {
      commit("setVisibleModalSeleccionNave", data);
    },
    actionSetVisibleModalSeleccionNaveActualizar({ commit }, data) {
      commit("setVisibleModalSeleccionNaveActualizar", data);
    },
    actionSetVisibleModalReservaBookingAux({ commit }, data) {
      commit("setVisibleModalReservaBookingAux", data);
    },
    actionSetVisibleModalSeleccionarTickeadosConfirmados({ commit }, data) {
      commit("setVisibleModalSeleccionarTickeadosConfirmados", data);
    },
    actionSetVisibleModalSeleccionarTickeadosSolicitados({ commit }, data) {
      commit("setVisibleModalSeleccionarTickeadosSolicitados", data);
    },
    // Editar Simple Acuerdo Linea
    actionSetVisibleModalEditarSimpleAcuerdoLinea({ commit }, data) {
      commit("setVisibleModalEditarSimpleAcuerdoLinea", data);
    },
    actionSetVisibleModalVerRecargosAsociados({ commit }, data) {
      commit("setVisibleModalVerRecargosAsociados", data);
    },
    actionSetVisibleModalVerHistorialClientesBase({ commit }, data) {
      commit("setVisibleModalVerHistorialClientesBase", data);
    },
    actionSetVisibleModalDuplicarAcuerdoLinea({ commit }, data) {
      commit("setVisibleModalDuplicarAcuerdoLinea", data);
    },
    actionSetVisibleModalDuplicarContrato({ commit }, data) {
      commit("setVisibleModalDuplicarContrato", data);
    },
    // Editar Puerto Itinerario
    actionSetVisibleModalEditarPuertoItinerarios({ commit }, data) {
      commit("setVisibleModalEditarPuertoItinerarios", data);
    },
    // Actualizar y Filtrar
    actionSetFormFiltroAcuerdoCliente({ commit }, form) {
      commit("setFormFiltroAcuerdoCliente", form);
    },
    actionSetNuevoTransbordoAux({ commit }, data) {
      commit("setNuevoTransbordoAux", data);
    },
    actionSetPolAux({ commit }, data) {
      commit("setPolAux", data);
    },
    actionSetNaveAux({ commit }, data) {
      commit("setNaveAux", data);
    },
    actionSetViajeAux({ commit }, data) {
      commit("setViajeAux", data);
    },
    ActionSetVisibleModalUtilizarReservaAnterior({ commit }, data) {
      commit("setVisibleModalUtilizarReservaAnterior", data);
    },
    ActionSetContadorMenuBookings({ commit }, data) {
      commit("setContadorMenuBookings", data);
    },
    actionSetReservaInformacionGeneralModal({ commit }, data) {
      commit("setReservaInformacionGeneralModal", data);
    },
    actionSetSelectCommodities({ commit }, data) {
      commit("setSelectCommodities", data);
    },
    actionSetSelectAtmospheres({ commit }, data) {
      commit("setSelectAtmospheres", data);
    },
    actionSetSelectContainers({ commit }, data) {
      commit("setSelectContainers", data);
    },
    actionSetSelectContract({ commit }, data) {
      commit("setSelectContract", data);
    },
    actionSetVisibleModalInformacionPlanificacionAnual({ commit }, data) {
      commit("setVisibleModalInformacionPlanificacionAnual", data);
    },
    actionTariffSelectedRechargeAction({ commit }, data) {
      commit("setTariffSelectedRechargeAction", data);
    },
    actionModalAsignarTarifasRecargos({ commit }, data) {
      commit("setModalAsignarTarifasRecargos", data);
    },
    actionDataDatatableTarifasAcuerdosLineasFull({ commit }, data) {
      commit("setDataDatatableTarifasAcuerdosLineasFull", data);
    },
    actionSetHabilitarEdicionMultipleAnual({ commit }, data) {
      commit("setHabilitarEdicionMultipleAnual", data);
    },
    actionSetPuertosSeleccionadosPlanAnual({ commit }, data) {
      commit("setPuertosSeleccionadosPlanAnual", data);
    },
    actionSetCheckPlanificacionAnual({ commit }, data) {
      commit("setCheckPlanificacionAnual", data);
    },
    actionSetClearCheckPlanificacionAnual({ commit }, data) {
      commit("setClearCheckPlanificacionAnual", data);
    },
    actionSetDataAnioSeleccionado({ commit }, data) {
      commit("setDataAnioSeleccionado", data);
    },
    actionSetLista_productos({ commit }, data) {
      commit("setLista_productos", data);
    },
    actionSetLista_anios({ commit }, data) {
      commit("setLista_anios", data);
    },
    actionSetLista_clientes({ commit }, data) {
      commit("setLista_clientes", data);
    },
    actionSetLista_serv_integral({ commit }, data) {
      commit("setLista_serv_integral", data);
    },
    actionSetLista_contenedores({ commit }, data) {
      commit("setLista_contenedores", data);
    },
    actionSetLista_consignatarios({ commit }, data) {
      commit("setLista_consignatarios", data);
    },
    actionSetLista_puertos({ commit }, data) {
      commit("setLista_puertos", data);
    },
    actionSetNuevosConsolidadoMultiples({ commit }, data) {
      commit("setNuevosConsolidadoMultiples", data);
    },
    actionSetNuevosPuertosMultiplesAgregados({ commit }, data) {
      commit("setNuevosPuertosMultiplesAgregados", data);
    },
    actionSetNuevosPlanificacionAnualMultiples({ commit }, data) {
      commit("setNuevosPlanificacionAnualMultiple", data);
    },
    actionSetPuertoParaEliminarPlanificacionAnual({ commit }, data) {
      commit("setPuertoParaEliminarPlanificacionAnual", data);
    },
    actionSetEliminacionConsolidado({ commit }, data) {
      commit("setEliminacionConsolidado", data);
    },
    actionSetEliminacionTab1({ commit }, data) {
      commit("setEliminacionTab1", data);
    },
    actionSetEliminacionTab2({ commit }, data) {
      commit("setEliminacionTab2", data);
    },
    actionSetEliminacionTab3({ commit }, data) {
      commit("setEliminacionTab3", data);
    },
    actionSetEliminacionTab4({ commit }, data) {
      commit("setEliminacionTab4", data);
    },
    actionSetProduct_selected({ commit }, data) {
      commit("setProduct_selected", data);
    },
    actionSetContainer_selected({ commit }, data) {
      commit("setContainer_selected", data);
    },
    actionSetAnnual_plan_id({ commit }, data) {
      commit("setAnnual_plan_id", data);
    },
    actionSetConfirmacionEliminarPuerto({ commit }, data) {
      commit("setConfirmacionEliminarPuerto", data);
    },
    actionSetPSShowManageModal({ commit }, data) {
      commit("setPSShowManageModal", data);
    },
    actionSetPSShowReportModal({ commit }, data) {
      commit("setPSShowReportModal", data);
    },
    actionSetPSCreateMode({ commit }, data) {
      commit("setPSCreateMode", data);
    },
    actionSetPSMultipleEditMode({ commit }, data) {
      commit("setPSMultipleEditMode", data);
    },
    actionSetPSEnabledButtons({ commit }, data) {
      commit("setPSEnabledButtons", data);
    },
    actionSetPSWeekTotals({ commit }, data) {
      commit("setPSWeekTotals", data);
    },
    actionSetPSDataSelected({ commit }, data) {
      commit("setPSDataSelected", data);
    },
    actionSetPSShowDetail({ commit }, data) {
      commit("setPSShowDetail", data);
    },
    actionSetPSDetailPort({ commit }, data) {
      commit("setPSDetailPort", data);
    },
    actionSetPSIsAdmin({ commit }, data) {
      commit("setPSIsAdmin", data);
    },
    actionSetPSDataSelectedToDelete({ commit }, data) {
      commit("setPSDataSelectedToDelete", data);
    },
    actionSetPSNewPlanningProducts({ commit }, data) {
      commit("setPSNewPlanningsProducts", data);
    },
    actionSetPSExistingPlanningProducts({ commit }, data) {
      commit("setPSExistingPlanningsProducts", data);
    },
    actionSetPSAddedPlanningProducts({ commit }, data) {
      commit("setPSAddedPlanningsProducts", data);
    },
    actionSetPSResumeDataTable({ commit }, data) {
      commit("setPSResumeDataTable", data);
    },
    actionSetPSResumeDataTableFiltrada({ commit }, data) {
      commit("filterPSResumeDataTableFiltrada", data);
    },
    actionSetPSResumeDataTableNoFiltrada({ commit }, data) {
      commit("limpiarPSResumeDataTableResumenFiltrada", data);
    },
    actionSetPSDataTable({ commit }, data) {
      commit("setPSDataTable", data);
    },
    actionSetPSDataTableFiltrada({ commit }, data) {
      commit("filterPSDatatableFiltrada", data);
    },
    actionSetPSDataTableNoFiltrada({ commit }, data) {
      commit("limpiarPSDatatableFiltrada", data);
    },
    actionSetPSCurrentWeeks({ commit }, data) {
      commit("setPSCurrentWeeks", data);
    },
    actionSetPSListaClientes({ commit }, data) {
      commit("setPSListaClientes", data);
    },
    actionSetPSListaContendores({ commit }, data) {
      commit("setPSListaContenedores", data);
    },
    actionSetPSListaPuertos({ commit }, data) {
      commit("setPSListaPuertos", data);
    },
    actionSetPSListaProductos({ commit }, data) {
      commit("setPSListaProductos", data);
    },
    actionSetPSFiltroClientes({ commit }, data) {
      commit("setPSFiltroClientes", data);
    },
    actionSetPSFiltroSemanas({ commit }, data) {
      commit("setPSFiltroSemanas", data);
    },
    actionSetPSFiltroContendores({ commit }, data) {
      commit("setPSFiltroContenedores", data);
    },
    actionSetPSFiltroPuertos({ commit }, data) {
      commit("setPSFiltroPuertos", data);
    },
    actionSetPSEnabledNotifications({ commit }, data) {
      commit("setPSEnabledNotifications", data);
    },
    actionSetPSFiltroProductos({ commit }, data) {
      commit("setPSFiltroProductos", data);
    },
    actionSetDataPlanificacionAnualTabla({ commit }) {
      commit("setDataPlanificacionAnualTabla");
    },
    actionSetDataPlanificacionSemanalTabla({ commit }) {
      commit("setDataPlanificacionSemanalTabla");
    },
    actionSetPSFiltroAnios({ commit }, data) {
      commit("setPSFiltroAnios", data);
    },
    actionSetYearsFilter({ commit }, data) {
      commit("setYearsFilter", data);
    },
    actionSetClienstFilter({ commit }, data) {
      commit("setClienstFilter", data);
    },
    actionSetContainersFilter({ commit }, data) {
      commit("setContainersFilter", data);
    },
    actionSetProductsFilter({ commit }, data) {
      commit("setProductsFilter", data);
    },
    actionSetServIntegralFilter({ commit }, data) {
      commit("setServIntegralFilter", data);
    },
    actionSetConsigneeFilter({ commit }, data) {
      commit("setConsigneeFilter", data);
    },
    actionSetPortFilter({ commit }, data) {
      commit("setPortFilter", data);
    },
    actionSetDataFiltradaPlanificacionAnual({ commit }, data) {
      commit("setDataFiltradaPlanificacionAnual", data);
    },
    actionSetPAShowReportModal({ commit }, data) {
      commit("setPAShowReportModal", data);
    },
    actionSetShowModalBuscarReservaDeclaradoAceptar({ commit }, data) {
      commit("setShowModalBuscarReservaDeclaradoAceptar", data);
    },
    actionsSetShowModalBuscarReservaDeclaradoVerDetalle({ commit }, data) {
      commit("setShowModalBuscarReservaDeclaradoVerDetalle", data);
    },
    actionSetShowModalBuscarReservaDeclaradoEditar({ commit }, data) {
      commit("setShowModalBuscarReservaDeclaradoEditar", data);
    },
    actionSetGoTabSolicitudReserva({ commit }, data) {
      commit("setGoTabSolicitudReserva", data);
    },
    actionSetInfoSolicitudModificacion({ commit }, data) {
      commit("setInfoSolicitudModificacion", data);
    },
    actionSetPolEtdItinerary({ commit }, data) {
      commit("setPolEtdItinerary", data);
    },
    actionSetStateIdDeclarados({ commit }, data) {
      commit("setStateIdDeclarados", data);
    },
    actionSetIdBookingItinerary({ commit }, data) {
      commit("setIdBookingItinerary", data);
    },
    actionSetInactiveDeleteTariffLineByFilter({ commit }, data) {
      commit("setInactiveDeleteTariffLineByFilter", data);
    },
    actionSetTariffRechargeDescription({ commit }, data) {
      commit("setTariffRechargeDescription", data);
    },
    actionSetLogistaasOptions({ commit }, data) {
      commit("setLogistaasOptions", data);
    },
    actionSetLoadingTableConfirmados({ commit }, data) {
      commit("setLoadingTableConfirmados", data);
    },
    actionSetIsBookingPlanned({ commit }, data) {
      commit("setIsBookingPlanned", data);
    },
    actionSetShowModalCostosSIBooking({ commit }, data) {
      commit("setShowModalCostosSIBooking", data);
    },

    actionSetLoadingItineraryTable({ commit }, data) {
      commit("setLoadingItineraryTable", data);
    },
    actionSetLoadingTableCancelados({ commit }, data) {
      commit("setLoadingTableCancelados", data);
    },
    actionSetLoadingTableCanceladosDeclarados({ commit }, data) {
      commit("setLoadingTableCanceladosDeclarados", data);
    },
    actionSetLoadingTableItinerarySearch({ commit }, data) {
      commit("setLoadingTableItinerarySearch", data);
    },
    actionSetShowModalfilterItinerary({ commit }, data) {
      commit("setShowModalfilterItinerary", data);
    },
    actionSetMethodPay({ commit }, data) {
      commit("setMethodPay", data);
    },
    actionSetShowModalfilterTariffLines({ commit }, data) {
      commit("setShowModalfilterTariffLines", data);
    },
    actionsSetShowModalImportRecharges({ commit }, data) {
      commit("setShowModalImportRecharges", data);
    },
    actionsSetShowModalTiposExtraCosto({ commit }, data) {
      commit("setShowModalTiposExtraCosto", data);
    },
    actionsSetShowModalRechargesNavieras({ commit }, data) {
      commit("setShowModalRechargesNavieras", data);
    },
    actionSetDataDataTableQuotationImporter({ commit }, data) {
      commit("setDataDataTableQuotationImporter", data);
    },
    actionSetDataDataTableQuotationImporterLoading({ commit }, data) {
      commit("setDataDataTableQuotationImporterLoading", data);
    },
    actionSetShowDataTableQuotationImporterModal({ commit }, data) {
      commit("setShowDataTableQuotationImporterModal", data);
    },

    actionsSetDataExtraCostosTipos({ commit }, data) {
      commit("setDataExtraCostosTipos", data);
    },
    actionsSetDataNumeroContenedor({ commit }, data) {
      commit("setDataNumeroContenedor", data);
    },

    actionsSetFiltroDataExtraCostosTipos({ commit }, data) {
      commit("setFiltroDataExtraCostosTipos", data);
    },
    actionsSetLimpiarFiltroDataExtraCostosTipos({ commit }) {
      commit("setLimpiarFiltroDataExtraCostosTipos");
    },
    actionsSetDataExtraCostos({ commit }, data) {
      commit("setDataExtraCostos", data);
    },
    actionsSetFilterDataExtraCostos({ commit }, data) {
      commit("setFilterDataExtraCostos", data);
    },
    actionsResetFilterDataExtraCostos({ commit }) {
      commit("resetFilterDataExtraCostos");
    },
    actionsSetShowModalExtraCosto({ commit }, data) {
      commit("setShowModalExtraCosto", data);
    },
    actionsSetFormasPagoLista({ commit }, data) {
      commit("setFormasPagoLista", data);
    },
    actionsSetTipoUnidadLista({ commit }, data) {
      commit("setTipoUnidadLista", data);
    },
    actionsSetTiposExtraCostos({ commit }, data) {
      commit("setTiposExtraCostos", data);
    },
    actionsSetTiposMonedasLista({ commit }, data) {
      commit("setTiposMonedasLista", data);
    },
    actionsSetTiposCargosLista({ commit }, data) {
      commit("setTiposCargosLista", data);
    },
    actionsSetShowModalAddValueDictionary({ commit }, data) {
      commit("setShowModalAddValueDictionary", data);
    },

    //descuentos clientes
    actionsSetShowModalCustomerDiscountsRecharges({ commit }, data) {
      commit("setShowModalCustomerDiscountsRecharges", data);
    },

    //tarifas de lineas
    actionsSetShowModalTariffLinesRecharges({ commit }, data) {
      commit("setShowModalTariffLinesRecharges", data);
    },

    actionSetRechargeTypes({ commit }, data) {
      commit("setRechargeTypes", data);
    },

    actionSetDataProveedores({ commit }, data) {
      commit("setDataProveedores", data);
    },

    actionSetLoadingAdmExtraCostos({ commit }, data) {
      commit("setLoadingAdmExtraCostos", data);
    },
    actionsSetDataPlantsProveedores({ commit }, data) {
      commit("setDataPlantsProveedores", data);
    },
    actionSetCurrentFiltersPlanificacionSemanal({ commit }, data) {
      commit("setCurrentFiltersPlanificacionSemanal", data);
    },
    actionSetVisibleModalAgregarBlNumber({ commit }, data) {
      commit("setVisibleModalAgregarBlNumber", data);
    },


  },
};
